import { ReactComponent as MergeIcon } from 'assets/icons/arrow-merge.svg'
import BreadCrumbs from 'components/breadcrumbs'
import { ResponsiveActionButton } from 'components/Buttons'
import CustomButton from 'components/Buttons/CustomButton'
import SvgIcon from 'components/Icon/SvgIcon'
import LihatDetail from 'components/Icons/LihatDetail'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import PMBPagination from 'components/PMBPagination'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import PMBProjectSelections from 'components/PMBProjectSelections'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import PMBSelect from 'components/PMBSelect'
import PMBTooltip from 'components/PMBTooltip'
import SidebarDetails from 'components/SidebarDetails'
import { TableComponent as DataTable } from 'components/TableComponent'
import {
  actionFilter,
  groupActionMenu,
  itemUnitList,
  menusStock2,
  menuStock,
} from 'constants'
import { AbilityContext, Can } from 'context/Acl'
import {
  capitalizeEveryWord,
  formatNumber,
  getActionWording,
  useDebounce,
} from 'helpers'
import moment from 'moment-timezone'
import { useSnackbar } from 'notistack'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import {
  CheckCircle,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Codepen,
  Copy,
  DollarSign,
  Download,
  Edit2,
  Eye,
  FilePlus,
  Filter,
  FolderMinus,
  MinusSquare,
  MoreVertical,
  CornerUpRight,
  Plus,
  Printer,
  Trash2,
  Truck,
  X,
} from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setScanStatus } from 'features/private-views/scanner/scannerSlice'
import { useNavigate, useLocation } from 'react-router-dom'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import {
  Badge,
  Card,
  CardBody,
  CardText,
  Col,
  Collapse,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap'
import colors from 'Theme/colors'
import { formatDatePMB, formatDatePMBV2 } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import {
  URL_DETAIL_TRANSACTION,
  URL_INVENTORY,
  URL_TRANSFER_INVENTORY,
  URL_FORM_TRANSFER_INVENTORY,
} from 'utils/pathUrl'
import {
  BUSINESS_INVENTORY,
  BUSINESS_TRANSFER_INVENTORY,
  MANAGE,
} from 'utils/subjectActions'
import { default as P, default as Text } from '../../../components/Text/index'
import PremiumProgressModal from 'components/PremiumProgressModal'
import {
  createStock,
  createStockTrx,
  deleteInventory,
  fetchDynamicItems,
  fetchInventoryGroups,
  getAllInventory,
  getInventory,
  getItemsInventory,
  getLabelMenuItems,
  getPackingDetail,
  getWarehouse,
  manageGroupForGroup,
  mergeInventory,
  packingAddStock,
  removeInventory,
  removePacking,
  splitInventory,
  splitToManyInventory,
  transformInventory,
  updateInventory,
} from './API/manageStockAction'
import {
  ActionModal,
  AddStockGroupModal,
  AddStockModal,
  AddStockSidebar,
  // ConfirmRemoveModal,
  ConfirmRemoveMultipleModal,
  DetailModal,
  EditStockModal,
  IDStockModal,
  ItemModal,
  ItemUnitModal,
  MergeStockModal,
  ProcessSplitStockModal,
  SplitStockModal,
  BulkIDStockModal,
} from './Components'
import InventorySummaryCard from './Components/Card/InventorySummaryCard'
import AssignLotIDModal from './Components/Modal/AssignLotIDModal'
import ConfirmRemoveInventory from './Components/Modal/ConfirmRemoveInventory'
import MergeInventoryModal from './Components/Modal/MergeInventoryModal'
import ModalEditLotId from './Components/Modal/ModalEditLotId'
import ModalPacking from './Components/Modal/ModalPacking'
import ModalPindahGudang from './Components/Modal/ModalPindahGudang'
import ModalConfirmTransfer from './Components/Modal/ModalConfirmTransfer'
import ModalRemoveItemPacking from './Components/Modal/ModalRemoveItemPacking'
import ModalRemovePacking from './Components/Modal/ModalRemovePacking'
import ModalRenamePacking from './Components/Modal/ModalRenamePacking'
import TransformModal from './Components/Modal/TransformModal'
import { handleDownloadExcel } from './downloadInventory'
import { TableSkeleton, CardSkeleton } from 'components/Skeleton'
import './styles.css'

const JualIcon = ({ size = 14, className, style }) => (
  <DollarSign size={size} className={className} style={style} />
)

export default function ManageStock({
  isDetail,
  id,
  dataState,
  breadCrumbsData,
  onManageBreadCrumb,
}) {
  const actionMenuRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()

  const intl = useIntl()
  const debounceTimer = useRef(0)
  const debounceTimerGrup = useRef(0)
  // this effect re-runs when itemsInventory changes; open each deep link only once
  const openedInventoryKeyRef = useRef(null)
  const {
    detail,
    loading: isLoading,
    warehouses,
    itemsInventory,
    inventoryList: reduxInventoryList,
    inventoryTotalItems: reduxTotalItems,
    inventoryTotalPages: reduxTotalPages,
    inventoryCurrentPage: reduxCurrentPage,
    groupsInventory: reduxGroupsInventory,
  } = useSelector((s) => s.manageStock)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { profile, ownerData } = useSelector((s) => s.dashboard)
  const ability = useContext(AbilityContext)
  const canTransfer = ability?.can(MANAGE, BUSINESS_TRANSFER_INVENTORY)

  const [showModalTransfer, setShowModalTransfer] = useState(false)
  const [transferModalData, setTransferModalData] = useState(null)
  const [isCollectingTransferGroup, setIsCollectingTransferGroup] = useState(false)

  const [isShowFilter, setIsShowFilter] = useState(false)

  const [displayAmount, setDisplayAmount] = useState(null)
  const [displayUnitValue, setDisplayUnitValue] = useState(null)
  const [showModal, setShowModal] = useState({
    menuOption: false,
    detail: false,
    qrCode: false,
    remove: false,
    filter: false,
    edit: false,
    add: false,
    item: false,
    itemUnit: false,
    merge: false,
    split: false,
    confirmRemove: false,
    moveOutPacking: false,
    transform: false,
    groupAction: false,
    addItemToGroup: false,
    confirmSplit: false,
    editLotId: false,
    assignLotID: false,
    bulkQrCode: false,
  })
  const [modalInventoryList, setModalInventoryList] = useState([])
  const [modalInventoryTotalItems, setModalInventoryTotalItems] = useState(0)
  const [modalInventoryPage, setModalInventoryPage] = useState(0)
  const [isFetchingModalInventory, setIsFetchingModalInventory] = useState(false)
  const [isAutoSelectPrint, setIsAutoSelectPrint] = useState(false)
  const [selectedSort, setSelectedSort] = useState({
    type: 'createdAt',
    mode: 'desc',
  })

  const [selectedSortGroup, setSelectedSortGroup] = useState({
    type: 'updatedAt',
    mode: 'desc',
  })

  const [isFetch, setIsFetch] = useState('')
  const [inventoryGabungList, setInventoryGabungList] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [size, setSize] = useState(10)
  const inventoryList = reduxInventoryList
  const totalItems = reduxTotalItems
  const totalPages = reduxTotalPages

  const [selectedStock, setSelectedStock] = useState(null)
  const [selectedPacking, setSelectedPacking] = useState(null)
  const [searchInventory, setSearchInventory] = useState('')
  const [searchGrupInventory, setSearchGrupInventory] = useState('')
  const [selectedInventoryList, setSelectedInventoryList] = useState([])
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [isSelectingAll, setIsSelectingAll] = useState(false)

  const [selectedDataRemove, setSelectedDataRemove] = useState([])
  const [selectedGroupInventory, setSelectedGroupInventory] = useState([])
  const [itemsList, setItemsList] = useState([])
  const [dataStock, setDataStock] = useState({
    unit: 'Kg',
    description: '',
    ownerCode: '',
  })
  const [selectedUnit, setSelectedUnit] = useState(() => {
    const defaultUnit = itemUnitList?.find(
      (u) => u?.title?.toLowerCase() === 'kg',
    )
    return defaultUnit
      ? {
          value: defaultUnit.title?.toLowerCase(),
          label: defaultUnit.title,
          ...defaultUnit,
        }
      : { value: 'kg', label: 'Kg' }
  })
  const [selectedEditAction, setSelectedEditAction] = useState({})
  const [position, setPosition] = useState({})
  const [locationBlocked, setLocationBlocked] = useState(false)
  const [splitItems, setSplitItems] = useState([])
  const [enableSplit, setEnableSplit] = useState(false)
  const [indexSelectedSplitStock, setIndexSelectedSplitStock] = useState(null)
  const [isFetchingMenus, setIsFetchingMenus] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState({})
  const [showSizeOption, setShowSizeOption] = useState(false)
  const [idsGroup, setIdsGroup] = useState([])
  const [selectedFolder, setSelectedFolder] = useState({})
  const [bulkSplitCount, setBulkSplitCount] = useState(1)
  const [isFetchSummary, setFetchSummary] = useState(false)

  const defaultWarehouse = JSON.parse(
    localStorage.getItem('defaultWarehouseInventory'),
  )
  const [loading, setLoading] = useState({
    create: false,
    getItems: false,
    getInventory: false,
    dynamicMenu: false,
    removeStock: false,
    merge: false,
  })
  const inventoryPromiseRef = useRef(null)
  const groupPromiseRef = useRef(null)

  useEffect(() => {
    return () => {
      if (inventoryPromiseRef.current) inventoryPromiseRef.current.abort()
      if (groupPromiseRef.current) groupPromiseRef.current.abort()
    }
  }, [])

  const [toast, setToast] = useState({
    show: false,
    title: '',
    type: '',
  })

  // STATE FOR PROSES TRANFORM
  const unitOptions = itemUnitList?.map((item) => ({
    value: item?.title,
    label: item?.title,
  }))
  const [notes, setNotes] = useState('')
  const [transformItems, setTransformItems] = useState([
    {
      ownerCode: null,
      amount: 0,
      unitValue: 0,
      itemId: null,
      description: '',
      unit: unitOptions?.[0]?.value,
    },
  ])

  const [paginationGroup, setPaginationGroup] = useState({ size: 12 })
  const [clearRows, setClearRows] = useState(false)
  const [clearRowsGroup, setClearRowsGroup] = useState(false)
  const toggleClearRows = () => {
    setClearRows(!clearRows)
  }
  const toggleClearRowsGroup = () => {
    setClearRowsGroup(!clearRowsGroup)
  }
  const [paginationGabung, setPaginationGabung] = useState({ currentPage: 0 })
  const [dynamicMenus, setDynamicMenus] = useState([])
  const [isTransform, setIsTransform] = useState(false)
  const [page, setPage] = useState(() => {
    const state = window.history.state
    return state && state.page ? state.page : 0
  })

  const [isSubGroup, setIsSubGroup] = useState(false)
  const [currentGroups, setCurrentGroups] = useState(
    reduxGroupsInventory?.items || [],
  )
  const [currentFolder, setCurrentFolder] = useState([])
  const [parentGroupId, setParentGroupId] = useState(null)
  const [actionType, setActionType] = useState('')
  const [isDownload, setIsDownload] = useState(false)
  const [isCollectingGroup, setIsCollectingGroup] = useState(false)
  const [collectingCurrent, setCollectingCurrent] = useState(0)
  const [collectingTotal, setCollectingTotal] = useState(0)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const dataInventories = useMemo(() => ({
    items: reduxInventoryList,
    totalItems: reduxTotalItems,
    totalPages: reduxTotalPages,
    currentPage: reduxCurrentPage
  }), [reduxInventoryList, reduxTotalItems, reduxTotalPages, reduxCurrentPage])

  const [dateFilter, setDateFilter] = useState({
    from: moment().subtract(3, 'months').startOf('day').toISOString(),
    to: moment().endOf('day').toISOString(),
  })
  const [projectFilter, setProjectFilter] = useState(null)
  const projectFilterRef = useRef(projectFilter)
  const [statusFilter, setStatusFilter] = useState({
    value: '',
    label: 'Semua Keterangan',
  })
  const isCollectingRef = useRef(false)

  // -- SELECT ALL LOGIC START (Moved here to access dataInventories) --

  const checkRowSelected = useCallback(
    (row) => selectedInventoryList.some((r) => r.id === row.id),
    [selectedInventoryList],
  )

  const handleRowSelected = useCallback(
    (state) => {
      // 1. Get IDs of items on the current page
      const currentPageIds = inventoryList?.map((item) => item?.id)

      // 2. Filter out current page items from the global 'selectedInventoryList'
      const otherPageItems = selectedInventoryList?.filter(
        (row) => !currentPageIds?.includes(row?.id),
      )

      // 3. Combine "other page items" + "newly selected items on this page"
      const newSelectedRows = [...otherPageItems, ...state.selectedRows]

      // Prevent infinite loop/flickering: Only update state if the selection actually changed
      const isSameSelection =
        newSelectedRows?.length === selectedInventoryList?.length &&
        newSelectedRows.every((newItem) =>
          selectedInventoryList.some((oldItem) => oldItem?.id === newItem?.id),
        )

      if (isSameSelection) {
        return
      }

      setSelectedInventoryList(newSelectedRows)

      // Check if we still have "All" selected
      const isComplete = newSelectedRows.length === totalItems
      if (isAllSelected && !isComplete) {
        setIsAllSelected(false)
      } else if (!isAllSelected && isComplete && totalItems > 0) {
        // Optional: Auto-enable "Select All" mode if user manually selects everything
        setIsAllSelected(true)
      }
    },
    [isAllSelected, inventoryList, selectedInventoryList, totalItems],
  )

  const handleSelectAll = useCallback(async () => {
    // Gmail-style: User requested to select *everything* matching current filter
    try {
      setIsSelectingAll(true)
      const payload = {
        page: 0,
        size: 9999, // Request all items
        search: searchInventory,
        sortBy: selectedSort?.type,
        asc: selectedSort?.mode,
        ...(!isDetail && {
          warehouseId: defaultWarehouse?.id ?? 'null',
        }),
        ...(isDetail || searchInventory
          ? {
              groupId: id,
            }
          : { groupId: 'null' }),
        all: true,
      }

      if (dateFilter?.from && dateFilter?.to) {
        payload.dateFrom = dateFilter.from
        payload.dateTo = dateFilter.to
      }
      if (statusFilter?.value) {
        payload.method = statusFilter.value
      }
      const effectiveProjectId = projectFilterRef.current?.value ?? null
      if (effectiveProjectId || effectiveProjectId === 0) {
        payload.projectId = effectiveProjectId
      }

      // Use the new independent thunk to avoid flickering the main table
      const res = await dispatch(getAllInventory(payload)).unwrap()

      if (res?.items) {
        // Filter out disabled items (pending === true)
        const validItems = res.items.filter((item) => item?.pending !== true)
        setSelectedInventoryList(validItems)
        setIsAllSelected(true)
      }
    } catch (error) {
      console.error('Failed to select all items:', error)
      enqueueSnackbar('Gagal memilih semua items.', { variant: 'error' })
    } finally {
      setIsSelectingAll(false)
    }
  }, [
    dataInventories,
    searchInventory,
    selectedSort,
    defaultWarehouse,
    isDetail,
    id,
    dateFilter,
    statusFilter,
    dispatch,
  ])

  // Export every row matching the table's filters, not just the loaded page
  const handleExportInventory = async () => {
    const payload = {
      page: 0,
      size: totalItems || size,
      search: searchInventory,
      sortBy: selectedSort?.type,
      asc: selectedSort?.mode,
      ...(!isDetail && {
        warehouseId: defaultWarehouse?.id ?? 'null',
      }),
      ...(isDetail
        ? { groupId: id }
        : searchInventory
          ? {}
          : { groupId: 'null' }),
      all: true,
    }
    if (dateFilter?.from && dateFilter?.to) {
      payload.dateFrom = dateFilter.from
      payload.dateTo = dateFilter.to
    }
    if (statusFilter?.value) {
      payload.method = statusFilter.value
    }
    const effectiveProjectId = projectFilterRef.current?.value ?? null
    if (effectiveProjectId || effectiveProjectId === 0) {
      payload.projectId = effectiveProjectId
    }

    try {
      const res = await dispatch(getAllInventory(payload)).unwrap()
      handleDownloadExcel(
        { items: res?.items ?? [], totalItems: res?.items?.length ?? 0 },
        setIsDownload,
        setFirstRows,
        setTotalRows,
        columns,
        warehouses?.newData,
        defaultWarehouse?.id,
      )
    } catch (error) {
      enqueueSnackbar('Gagal mengunduh data.', { variant: 'error' })
    }
  }

  const handleClearSelection = useCallback(() => {
    setIsAllSelected(false)
    toggleClearRows()
    setSelectedInventoryList([])
  }, [clearRows])

  // Count selected items that are NOT on the current page
  const otherPageSelectedCount = useMemo(() => {
    const currentPageIds = new Set(inventoryList?.map((item) => item?.id) || [])
    return selectedInventoryList.filter(
      (item) => !currentPageIds.has(item?.id),
    ).length
  }, [selectedInventoryList, inventoryList])

  // -- SELECT ALL LOGIC END --
  const statusOptions = [
    { value: '', label: 'Semua Keterangan' },
    ...actionFilter,
  ]

  const handleResetDataStock = () => {
    setDataStock((prev) => ({
      unit: 'Kg',
      description: '',
      ownerCode: '',
      amount: null,
      itemId: null,
      nameItem: '',
      linkFoto: null,
      unitValue: null,
      warehouseId: prev?.warehouseId || defaultWarehouse?.id || null,
      recordTime: null,
      landplottingId: null,
      note: '',
      sellerPhone: null,
      bundle: null,
    }))
  }

  const onHandleResetNewTransform = () => {
    setDynamicMenus([])
    setSelectedStock({})
    // reset to default unit option (Kg) so Satuan UI stays populated
    const defaultUnit = itemUnitList?.find(
      (u) => u?.title?.toLowerCase() === 'kg',
    )
    setSelectedUnit(
      defaultUnit
        ? {
            value: defaultUnit.title?.toLowerCase(),
            label: defaultUnit.title,
            ...defaultUnit,
          }
        : { value: 'kg', label: 'Kg' },
    )
    setIsTransform(false)
    handleResetDataStock()
    setNotes('')
    setTransformItems([
      {
        ownerCode: null,
        amount: 0,
        unitValue: 0,
        itemId: null,
        description: '',
        unit: unitOptions?.[0]?.value,
      },
    ])
  }

  useEffect(() => {
    if (!warehouses || warehouses?.newData?.length === 0) {
      dispatch(getWarehouse({ isForFilter: true }))
    }
  }, [dispatch, warehouses])

  useEffect(() => {
    if (
      location?.state?.action === 'createInventory' &&
      location?.state?.qrItems?.length > 0
    ) {
      const item = location.state.qrItems[0]
      const itemNameFromQr =
        item?.nameItem || item?.name || item?.productDescription || ''
      const toNumberSafe = (value) => {
        if (value === null || value === undefined || value === '') return null
        if (typeof value === 'number' && Number.isFinite(value)) return value
        const direct = Number(String(value).trim())
        return Number.isNaN(direct) ? null : direct
      }

      if (!Array.isArray(itemsInventory) || itemsInventory.length === 0) {
        dispatch(getItemsInventory()).catch(() => null)
      }

      const warehouseIdRaw =
        item?.gudang ??
        item?.['gudang?'] ??
        item?.warehouseId ??
        item?.warehouse?.id ??
        item?.warehouse?.value ??
        item?.warehouse ??
        item?.gudangId ??
        item?.gudangName ??
        item?.warehouseName ??
        null
      const warehouseId = toNumberSafe(warehouseIdRaw) ?? warehouseIdRaw

      setDataStock((prev) => ({
        ...prev,
        itemId: item?.itemId ?? item?.serial ?? item?.ser ?? item?.id ?? null,
        nameItem: itemNameFromQr,
        amount: item?.amount ?? item?.qty ?? null,
        traceCode: item?.traceCode || '',
        ...(warehouseId !== null &&
        warehouseId !== undefined &&
        warehouseId !== ''
          ? { warehouseId }
          : {}),
      }))

      const resolvedItemId =
        item?.itemId ?? item?.serial ?? item?.ser ?? item?.id
      if (resolvedItemId) {
        setSelectedStock({
          id: resolvedItemId,
          value: resolvedItemId,
          itemId: resolvedItemId,
          traceCode: item?.traceCode || '',
          ...(itemNameFromQr ? { nameItem: itemNameFromQr } : {}),
        })
      } else if (itemNameFromQr) {
        setSelectedStock({
          nameItem: itemNameFromQr,
          traceCode: item?.traceCode || '',
        })
      }

      setShowModal((prev) => ({ ...prev, add: true }))

      // Clean up state to prevent re-triggering
      const newState = { ...location.state }
      delete newState.action
      delete newState.qrItems
      // Clean up state
      window.history.replaceState({}, document.title)
    }

    if (
      location?.state?.action === 'searchInventory' &&
      location?.state?.query
    ) {
      const query = location.state.query
      setSearchInventory(query)

      // Trigger search immediately
      fetchInventory(
        0,
        size,
        query,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )

      // Clean up state
      window.history.replaceState({}, document.title)
    }

    // From transaction detail (which already checked the inventory exists): open its detail panel
    if (
      location?.state?.action === 'openInventory' &&
      location?.state?.row &&
      openedInventoryKeyRef.current !== location.key
    ) {
      openedInventoryKeyRef.current = location.key
      const { row } = location.state
      window.history.replaceState({}, document.title)
      setSelectedStock({ ...row?.item, ...row })
      onShowHideModal('detail', true, 'general')
    }
  }, [location?.state, dispatch, itemsInventory])

  useEffect(() => {
    if (
      !showModal?.add ||
      !Array.isArray(itemsInventory) ||
      itemsInventory.length === 0
    ) {
      return
    }

    const normalizedItemId =
      dataStock?.itemId !== null && dataStock?.itemId !== undefined
        ? String(dataStock.itemId)
        : ''
    const normalizedName = String(dataStock?.nameItem || '')
      .trim()
      .toLowerCase()

    const matchedById = normalizedItemId
      ? itemsInventory.find((it) => String(it?.id) === normalizedItemId)
      : null

    const matchedByName =
      !matchedById && normalizedName
        ? itemsInventory.find(
            (it) =>
              String(it?.nameItem || '')
                .trim()
                .toLowerCase() === normalizedName,
          )
        : null

    const matchedItem = matchedById || matchedByName
    if (!matchedItem) return

    const shouldUpdateDataStock =
      String(dataStock?.itemId || '') !== String(matchedItem?.id) ||
      String(dataStock?.nameItem || '') !== String(matchedItem?.nameItem || '')

    if (shouldUpdateDataStock) {
      setDataStock((prev) => ({
        ...prev,
        itemId: matchedItem?.id,
        nameItem: matchedItem?.nameItem,
        linkFoto: prev?.linkFoto || matchedItem?.linkFoto,
      }))
    }

    setSelectedStock((prev) => ({
      ...(prev || {}),
      id: matchedItem?.id,
      value: matchedItem?.id,
      itemId: matchedItem?.id,
      nameItem: matchedItem?.nameItem,
      linkFoto: matchedItem?.linkFoto,
    }))
  }, [showModal?.add, itemsInventory, dataStock?.itemId, dataStock?.nameItem])

  useEffect(() => {
    if (warehouses?.newData?.length > 0) {
      fetchInventory(
        0,
        10,
        location?.state?.action === 'searchInventory' ? location.state.query : searchInventory,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
      setFetchSummary(true)
      if (id) {
        fetchGroupInventory(0, paginationGroup?.size, '', '', '', '', id)
      }

      if (!isDetail) {
        fetchGroupInventory(
          0,
          paginationGroup?.size,
          searchGrupInventory,
          selectedSortGroup?.type,
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
        )
      }
    }
  }, [isDetail, warehouses, id])

  useEffect(() => {
    if (isDetail && id) {
      setCurrentGroups([])
      setLoading((prev) => ({ ...prev, getInventory: true, group: true }))
    }
    // Clear selection when navigating to a different group/page
    // to prevent stale selections from carrying over
    setSelectedInventoryList([])
    setSelectedDataRemove([])
    setIsAllSelected(false)
    toggleClearRows()
  }, [id, isDetail])

  useEffect(() => {
    if (isDetail && id && String(detail?.id) !== String(id)) {
      dispatch(getPackingDetail({ page: 0, id }))
    }
  }, [isDetail, id, detail, dispatch])

  useEffect(() => {
    projectFilterRef.current = projectFilter
  }, [projectFilter])

  // HANDLE DEFAULT WAREHOUSE
  useEffect(() => {
    if (warehouses?.newData?.length > 0) {
      const storedWarehouse = JSON.parse(
        localStorage.getItem('defaultWarehouseInventory'),
      )
      const validWarehouse = warehouses?.newData?.find(
        (warehouse) => warehouse.id === storedWarehouse?.id,
      )

      if (!validWarehouse) {
        const defaultWarehouse = warehouses.newData[0]
        localStorage.setItem(
          'defaultWarehouseInventory',
          JSON.stringify(defaultWarehouse),
        )
      }
    }
  }, [warehouses])

  const isFirstRun = useRef(true)

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }
    fetchInventory(
      currentPage,
      size,
      searchInventory,
      selectedSort?.type,
      selectedSort?.mode,
      defaultWarehouse?.id,
      id,
      dateFilter?.from,
      dateFilter?.to,
      statusFilter?.value,
      projectFilterRef.current?.value || null,
    )
  }, [currentPage, size])

  useEffect(() => {
    if (isFetch) {
      setFetchSummary(true)
      if (isFetch === 'all') {
        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        fetchGroupInventory(
          paginationGroup?.currentPage ?? 0,
          paginationGroup?.size,
          searchGrupInventory,
          selectedSortGroup?.type,
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
          id,
        )
      } else if (isFetch === 'grup') {
        fetchGroupInventory(
          paginationGroup?.currentPage ?? 0,
          paginationGroup?.size,
          searchGrupInventory,
          selectedSortGroup?.type,
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
          id,
        )
      } else {
        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        fetchGroupInventory(
          0,
          9999,
          '',
          selectedSortGroup?.type || 'updatedAt',
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
          parentGroupId,
          '',
        )
        toggleClearRowsGroup()
        toggleClearRows()
      }
    }
  }, [isFetch])

  // FETCHING LABEL DYNAMICS
  const fetchLabelItems = async (data) => {
    try {
      setIsFetchingMenus(true)
      const response = await dispatch(
        getLabelMenuItems({ rawItemId: data?.itemId }),
      ).unwrap()
      const newMenus = response?.items?.map((item) => ({
        id: Number(`${Date.now()}${Math.floor(Math.random() * 100000)}`),
        title: item?.createMethodLabel,
        screen: '/manage-stock/edit',
        type: 'edit',
        editType: 'general',
        modal: 'transform',
      }))
      setDynamicMenus(newMenus)
    } catch (error) {
      console.warn(error)
      enqueueSnackbar('Gagal mengambil data label items.', { variant: 'error' })
    } finally {
      setIsFetchingMenus(false)
    }
  }

  // HANDLE GET ITEMS DYANMIC BASED ON MENU/LABEL
  const handleDynamicMenuClick = async (menu, itemId) => {
    if (!menu?.id || !itemId) {
      enqueueSnackbar('Data tidak valid untuk memuat item.', {
        variant: 'error',
      })
      return
    }

    try {
      setLoading((prevState) => ({ ...prevState, dynamicMenu: true }))

      const response = await dispatch(
        fetchDynamicItems({
          createMethodLabel: menu.title,
          rawItemId: itemId,
        }),
      ).unwrap()
      setIsTransform(true)
      setItemsList(response?.items)
      onShowHideModal(menu.modal, true)
    } catch (error) {
      enqueueSnackbar('Gagal memuat item dinamis.', { variant: 'error' })
      console.warn('Error fetching dynamic items:', error)
    } finally {
      setLoading((prevState) => ({ ...prevState, dynamicMenu: false }))
    }
  }

  // MERGED MENU STOCK FOR TRANSFORM
  const mergedMenusStock2 = isFetchingMenus
    ? []
    : dynamicMenus.length > 0
      ? dynamicMenus
      : menusStock2 || []

  const fetchInventory = useDebounce((
    page,
    size,
    search,
    sortBy,
    asc,
    warehouseId,
    groupId = id,
    dateFrom = null,
    dateTo = null,
    action = null,
    projectId = null,
    isScanner = false,
  ) => {
    if (isScanner) {
      dispatch(setScanStatus({ status: 'processing' }))
    }
    const payload = {
      page: page,
      size: size,
      search: search,
      sortBy: sortBy,
      asc: asc,
      ...(!isDetail && {
        warehouseId: warehouseId ?? 'null',
      }),
      ...(isDetail
        ? {
            groupId: groupId,
          }
        : search
          ? {}
          : { groupId: 'null' }),
      all: true,
    }

    if (dateFrom && dateTo) {
      payload.dateFrom = dateFrom
      payload.dateTo = dateTo
    }
    if (action && action !== '') {
      payload.method = action
    }
    const effectiveProjectId =
      projectId ?? projectFilterRef.current?.value ?? null
    if (effectiveProjectId || effectiveProjectId === 0) {
      payload.projectId = effectiveProjectId
    }
    if (!inventoryList || inventoryList.length === 0) {
      setLoading((prevState) => ({ ...prevState, getInventory: true }))
    }
    if (inventoryPromiseRef.current) {
      inventoryPromiseRef.current.abort()
    }
    inventoryPromiseRef.current = dispatch(getInventory(payload))
    inventoryPromiseRef.current
      .then((res) => {
        const responseItems = res?.payload?.items || []

        if (isScanner) {
          dispatch(setScanStatus({ status: 'idle' }))
        }

        if (
          isDetail &&
          typeof onManageBreadCrumb === 'function' &&
          responseItems.length > 0
        ) {
          const firstItem = responseItems[0]
          const labelFromInventoryApi =
            firstItem?.group?.label ||
            firstItem?.group?.name ||
            firstItem?.groupLabel ||
            firstItem?.label ||
            null

        const currentCrumb = breadCrumbsData?.find(
          (c) => String(c.id) === String(groupId ?? id),
        )

          if (
            labelFromInventoryApi &&
            currentCrumb?.label !== labelFromInventoryApi
          ) {
            onManageBreadCrumb({
              id: String(groupId ?? id),
              label: labelFromInventoryApi,
            })
          }
        }
      })
      .catch(() => {
        setLoading((prevState) => ({ ...prevState, getInventory: false }))
        if (isScanner) {
          dispatch(setScanStatus({ status: 'idle' }))
        }
      })
      .finally(() => {
        setLoading((prevState) => ({ ...prevState, getInventory: false }))
        setIsFetch('')
      })
  }, 300)

  const fetchGabungInventory = (page, row) => {
    setLoading((prevState) => ({ ...prevState, merge: true }))
    dispatch(
      getInventory({
        page: page,
        excludeId: row?.id,
        all: true,
        warehouseId: defaultWarehouse?.id ?? 'null',
        ...(isDetail
          ? {
              groupId: id,
            }
          : searchInventory
            ? {}
            : { groupId: 'null' }),
        ...(projectFilterRef.current?.value && {
          projectId: projectFilterRef.current.value,
        }),
      }),
    )
      .then((res) => {
        setInventoryGabungList(res?.payload?.items)
        setLoading((prevState) => ({ ...prevState, merge: false }))
        setPaginationGabung({
          totalPages: res?.payload?.totalPages,
          currentPage: res?.payload?.currentPage,
        })
      })
      .finally(() => {
        setLoading((prevState) => ({ ...prevState, merge: false }))
      })
  }

  const fetchGroupInventory = useDebounce((
    page,
    size,
    search,
    sortBy,
    asc,
    warehouseId,
    parentGroupId,
    type,
  ) => {
    const hasData = type === 'folder' ? currentFolder?.length > 0 : currentGroups?.length > 0
    if (!hasData) {
      setLoading((prevState) => ({ ...prevState, group: true }))
    }
    if (groupPromiseRef.current) {
      groupPromiseRef.current.abort()
    }
    groupPromiseRef.current = dispatch(
      fetchInventoryGroups({
        page: page,
        size: size,
        search: search,
        sortBy: sortBy,
        asc: asc,
        warehouseId: warehouseId ?? 'null',
        parentGroupId: parentGroupId ?? '',
      }),
    )
    groupPromiseRef.current
      .then((res) => {
        if (type === 'folder') {
          setCurrentFolder(
            res?.payload?.items?.map((item) => ({
              ...item,
              menuOption: false,
            })),
          )
        } else {
          setCurrentGroups(
            res?.payload?.items?.map((item) => ({
              ...item,
              menuOption: false,
            })),
          )
        }
        setPaginationGroup((prev) => ({
          ...prev,
          totalPages: res?.payload?.totalPages,
          currentPage: res?.payload?.currentPage,
          totalItems: res?.payload?.totalItems,
        }))
        setParentGroupId(parentGroupId)
      })
      .finally(() => {
        setLoading((prevState) => ({ ...prevState, group: false }))
        setIsFetch('')
      })
  }, 300)

  const fetchItemsInventory = useCallback(async () => {
    if (itemsInventory?.length > 0) return
    setLoading((prevState) => ({ ...prevState, item: true }))
    try {
      await dispatch(getItemsInventory()).unwrap()
    } catch (err) {
      console.error('Failed to fetch items inventory', err)
    } finally {
      setLoading((prevState) => ({ ...prevState, item: false }))
    }
  }, [dispatch, itemsInventory])

  const handleSort = (column, direction) => {
    setSelectedSort({ type: column?.sortField, mode: direction })
    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        searchInventory,
        column?.sortField,
        direction,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
    }
  }
  const handleDateChange = (dates) => {
    if (dates.length === 2) {
      const [start, end] = dates
      // PMBDateRangePicker returns dates in YYYY-MM-DD format with startOfDay/endOfDay applied
      const formattedStartDate = moment(start).startOf('day').toISOString()
      const formattedEndDate = moment(end).endOf('day').toISOString()
      setDateFilter({ from: formattedStartDate, to: formattedEndDate })

      if (currentPage !== 0) {
        setCurrentPage(0)
      } else {
        fetchInventory(
          0,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          formattedStartDate,
          formattedEndDate,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
      }
    }
  }

  const handleProjectChange = (selected) => {
    projectFilterRef.current = selected
    setProjectFilter(selected)
    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        searchInventory,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        selected?.value || null,
      )
    }
  }

  const clearDateFilter = () => {
    setDateFilter({ from: null, to: null })
    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        searchInventory,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        null,
        null,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
    }
  }

  const handleStatusChange = (selectedOption) => {
    setStatusFilter(selectedOption)

    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        searchInventory,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter.from,
        dateFilter.to,
        selectedOption?.value,
        projectFilterRef.current?.value || null,
      )
    }
  }

  const handleSortGroup = (column, direction) => {
    setSelectedSortGroup({ type: column?.sortField, mode: direction })
    fetchGroupInventory(
      0,
      paginationGroup?.size,
      searchGrupInventory,
      column?.sortField,
      direction,
      defaultWarehouse?.id,
    )
  }

  const handleFilterWarehouse = (filter) => {
    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        searchInventory,
        selectedSort?.sortField,
        selectedSort?.mode,
        filter === undefined ? 'null' : filter,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
    }

    // FILTER INVENTORY GRUP
    fetchGroupInventory(
      0,
      paginationGroup?.size,
      searchGrupInventory,
      selectedSortGroup?.sortField,
      selectedSortGroup?.mode,
      filter === undefined ? 'null' : filter,
    )
  }

  const onShowHideModal = (key, value, editType, index, data) => {
    if (editType) {
      if (editType === 'update') {
        setIsTransform(true)
      }
      setSelectedEditAction(editType)
    }
    if (index) {
      setIndexSelectedSplitStock(index)
    }
    if (key === 'split' && value) {
      addSplitItem(data, key, 2)
    }
    if (key === 'processSplit' && value) {
      addSplitItem(data, key, 1)
    }
    if (
      value === false &&
      !showModal?.item &&
      key !== 'itemUnit' &&
      dynamicMenus?.length > 0
    ) {
      onHandleResetNewTransform()
    }
    setPage((prevPage) => prevPage + 1)
    setShowModal((prevState) => ({
      ...prevState,
      menuOption: false,
      [key]: value,
    }))
    if (key === 'bulkQrCode' && value === false) {
      setModalInventoryList([])
      setModalInventoryTotalItems(0)
      setModalInventoryPage(0)
    }
    if (key === 'addItemToGroup' && value === false) {
      setSelectedFolder({})
      setIdsGroup([])
    }
  }

  const fetchModalInventory = async (pageToFetch = 0, isSelectAll = false) => {
    setIsFetchingModalInventory(true)
    try {
      const params = {
        page: pageToFetch,
        size: isSelectAll ? 9999 : 20,
        warehouseId: defaultWarehouse?.id,
        ...(searchInventory && { search: searchInventory }),
        sortBy: selectedSort?.type,
        asc: selectedSort?.mode,
        ...(!isDetail && {
          warehouseId: defaultWarehouse?.id ?? 'null',
        }),
        ...(isDetail || searchInventory ? { groupId: id } : { groupId: 'null' }),
      }

      if (dateFilter?.from && dateFilter?.to) {
        params.dateFrom = dateFilter.from
        params.dateTo = dateFilter.to
      }
      if (statusFilter?.value) {
        params.method = statusFilter.value
      }

      const response = await dispatch(getAllInventory(params)).unwrap()
      if (response?.items) {
        if (isSelectAll) {
          setModalInventoryList(response.items)
          setModalInventoryTotalItems(response.totalItems || response.items.length)
        } else {
          setModalInventoryList(prev => pageToFetch === 0 ? response.items : [...prev, ...response.items])
          setModalInventoryTotalItems(response.totalItems || response.items.length)
          setModalInventoryPage(pageToFetch)
        }
      }
    } catch (error) {
      console.error('Failed to fetch modal inventory:', error)
    } finally {
      setIsFetchingModalInventory(false)
    }
  }

  const addSplitItem = (data, key, amount = 1) => {
    if (!data?.id) {
      data = selectedStock
    }

    if (splitItems?.[0]?.amount === 1) {
      return
    }

    const totalNewCount = amount
    const lockedItems = splitItems?.filter((item) => item.locked) || []
    const unlockedItems = splitItems?.filter((item) => !item.locked) || []

    const totalLockedAmount = lockedItems.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0,
    )

    const remainingAmount = parseFloat(data?.amount || 0) - totalLockedAmount

    const baseItem = {
      nameItem:
        data?.nameItem || data?.SKU || data?.item?.nameItem || data?.item?.SKU,
      itemId: data?.itemId || data?.item?.id,
      unit: data?.unit,
      desc: data?.description || '',
      bundle: data?.bundle || '',
    }

    const newSplitItems = [...splitItems]

    // Tambahkan N bagian baru
    for (let i = 0; i < totalNewCount; i++) {
      newSplitItems.push({
        ...baseItem,
        amount: 0,
        locked: false,
      })
    }

    const updatedUnlockedItems = newSplitItems?.filter((item) => !item.locked)
    const unlockedCount = updatedUnlockedItems.length

    const base = Math.floor(remainingAmount / unlockedCount)
    const remainder = remainingAmount % unlockedCount

    let uIdx = 0
    const distributedItems = newSplitItems.map((item) => {
      if (item.locked) return item

      let amountAdded = base
      if (uIdx < Math.floor(remainder)) {
        amountAdded = base + 1
      } else if (uIdx === Math.floor(remainder) && remainder % 1 > 0) {
        amountAdded = base + (remainder % 1)
      }
      uIdx++

      return {
        ...item,
        amount: amountAdded,
      }
    })

    setSplitItems(distributedItems)
    setEnableSplit(distributedItems[0]?.amount > 1)
  }

  const onSelectStock = (item) => {
    setSelectedInventoryList((prevList) => {
      if (item?.selectedRows) {
        return item?.selectedRows
      } else if (prevList.includes(item.id)) {
        return prevList.filter((id) => id !== item.id)
      } else {
        return [...prevList, item.id]
      }
    })
  }

  const onSelectStockRemove = (item) => {
    setSelectedDataRemove((prevList) => {
      if (item?.selectedRows) {
        return item?.selectedRows
      } else if (prevList.includes(item.id)) {
        return prevList.filter((id) => id !== item.id)
      } else {
        return [...prevList, item.id]
      }
    })
  }

  const onSelectGroup = (item) => {
    setSelectedGroupInventory((prev) => {
      const exists = prev?.some((el) => el.id === item.id)

      if (exists) {
        return prev?.filter((el) => el.id !== item.id)
      } else {
        return [...prev, item]
      }
    })
  }
  const onSelectStockMenu = (item) => {
    setDisplayAmount(
      item?.amount !== undefined && item?.amount !== null
        ? String(item.amount).replace('.', ',')
        : '',
    )

    setSelectedStock({
      ...item?.item,
      ...item,
      amount:
        item?.amount !== undefined && item?.amount !== null
          ? String(item.amount).replace('.', ',')
          : '',
    })

    setDisplayUnitValue(item?.unitValue)
  }

  const onClickNextBack = (type, group, type2) => {
    if (group) {
      if (type === 'next') {
        fetchGroupInventory(
          paginationGroup?.currentPage + 1,
          paginationGroup?.size,
          searchInventory,
          selectedSortGroup?.sortField,
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
        )
      } else {
        fetchGroupInventory(
          paginationGroup?.currentPage - 1,
          paginationGroup?.size,
          searchInventory,
          selectedSortGroup?.sortField,
          selectedSortGroup?.mode,
          defaultWarehouse?.id,
        )
      }
    } else if (type2 === 'gabung') {
      if (type === 'next') {
        fetchGabungInventory(paginationGabung?.currentPage + 1, selectedStock)
      } else {
        fetchGabungInventory(paginationGabung?.currentPage - 1, selectedStock)
      }
    } else {
      if (type === 'next') {
        setCurrentPage(currentPage + 1)
      } else {
        setCurrentPage(currentPage - 1)
      }
    }
  }

  const handleSearchChange = (text) => {
    setSearchInventory(text)
    if (currentPage !== 0) {
      setCurrentPage(0)
    } else {
      fetchInventory(
        0,
        size,
        text,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
    }
  }

  useEffect(() => {
    const onScannerProductSearch = (event) => {
      const productName = String(event?.detail?.productName || '').trim()
      if (!productName) return

      setIsShowFilter(true)
      handleSearchChange(productName)

      enqueueSnackbar(`🔍 Mencari "${productName}"...`, {
        variant: 'info',
        autoHideDuration: 2000,
      })

      fetchInventory(
        0,
        size,
        productName,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
        true,
      )
    }

    document.addEventListener('scanner:product-search', onScannerProductSearch)
    return () => {
      document.removeEventListener(
        'scanner:product-search',
        onScannerProductSearch,
      )
    }
  }, [
    size,
    selectedSort?.type,
    selectedSort?.mode,
    defaultWarehouse?.id,
    id,
    dateFilter?.from,
    dateFilter?.to,
    statusFilter?.value,
  ])

  const handleSearchGroupChange = (text) => {
    setSearchGrupInventory(text)
    fetchGroupInventory(
      paginationGroup?.currentPage ?? 0,
      paginationGroup?.size,
      text,
      selectedSortGroup?.type || 'updatedAt',
      selectedSortGroup?.mode,
      defaultWarehouse?.id,
      id,
    )
  }

  const onSelectItem = (item) => {
    if (indexSelectedSplitStock >= 0) {
      let newItems = [...splitItems]
      newItems[indexSelectedSplitStock] = {
        ...newItems[indexSelectedSplitStock],
        itemId: item?.id,
        nameItem: item?.nameItem,
      }
      setSplitItems(newItems)
    }
    onChangeDataStock('nameItem', item?.nameItem)
    onChangeDataStock('itemId', item?.id)
    onChangeDataStock('linkFoto', item?.linkFoto)
    onChangeSelectedDataStock('nameItem', item?.nameItem)
    onChangeSelectedDataStock('itemId', item?.id)
    onChangeSelectedDataStock('linkFoto', item?.linkFoto)
    onShowHideModal('item', false)
  }

  const onSelectItemUnit = (item) => {
    setSelectedUnit(item)
    onChangeDataStock('unit', item?.title)
    onChangeSelectedDataStock('unit', item?.title)
    onShowHideModal('itemUnit', false)
    onChangeSelectedDataStock('unit', item?.title)
  }

  const onChangeSelectedDataStock = (key, value) => {
    if (key === 'amount') {
      setSelectedStock((prevState) => ({
        ...prevState,
        [key]: Number(value),
      }))
    } else {
      setSelectedStock((prevState) => ({
        ...prevState,
        [key]: value,
      }))
    }
  }

  const handleChangeInputSeparator = (key, value, func, data) => {
    setDisplayAmount(value)
    if (
      Number(
        value
          ?.replace(/[^\d,]/g, '')
          ?.replace?.(/\./g, '')
          ?.replace?.(/\,/g, '.'),
      ) !== data?.[key] &&
      func
    ) {
      func(
        key,
        Number(
          value
            ?.replace(/[^\d,]/g, '')
            ?.replace?.(/\./g, '')
            ?.replace?.(/\,/g, '.'),
        ),
      )
    }
  }

  const handleChangeInputUnitValueSeparator = (key, value, func, data) => {
    setDisplayUnitValue(value)
    if (
      Number(
        value
          ?.replace?.(/[^\d,]/g, '')
          ?.replace?.(/\./g, '')
          ?.replace?.(/\,/g, '.'),
      ) !== data?.[key] &&
      func
    ) {
      func(
        key,
        Number(
          value
            ?.replace?.(/[^\d,]/g, '')
            ?.replace?.(/\./g, '')
            ?.replace?.(/\,/g, '.'),
        ),
      )
    }
  }

  const onChangeDataStock = (key, value) => {
    if (key === 'amount' || key === 'unitValue') {
      setDataStock((prevState) => ({
        ...prevState,
        [key]: Number(value),
      }))
    } else {
      setDataStock((prevState) => ({
        ...prevState,
        [key]: value,
      }))
    }
  }

  const getMyLocation = async () => {
    try {
      if (!window.navigator || !window.navigator.geolocation) {
        throw new Error('Geolocation not supported by this browser.')
      }
      const location = window.navigator.geolocation

      const result = await new Promise((resolve, reject) => {
        location.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords?.latitude,
              longitude: position.coords?.longitude,
              locationBlocked: false,
            })
          },
          (error) => {
            let message = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                resolve({ locationBlocked: true })
                break
              case error.POSITION_UNAVAILABLE:
                message =
                  'Position unavailable. Please check your device or network.'
                reject(new Error(message))
                enqueueSnackbar(message, {
                  variant: 'error',
                })
                break
              case error.TIMEOUT:
                message = 'Location request timed out. Please try again.'
                reject(new Error(message))
                enqueueSnackbar(message, {
                  variant: 'error',
                })
                break
              default:
                message = 'Unknown geolocation error.'
                reject(new Error(message))
                enqueueSnackbar(message, {
                  variant: 'error',
                })
            }
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          },
        )
      })

      if (result.locationBlocked) {
        setLocationBlocked(true)
      } else {
        setPosition({
          latitude: result.latitude,
          longitude: result.longitude,
        })
        setLocationBlocked(false)
      }

      return result
    } catch (error) {
      console.error('Error getting location:', error)
      throw error
    }
  }

  const onCreateStock = async (type, selectedProject) => {
    setLoading((prevState) => ({ ...prevState, create: true }))
    const result = await getMyLocation()
    if (result?.locationBlocked) {
      enqueueSnackbar('Harap aktifkan lokasi pada perangkat Anda.', {
        variant: 'error',
      })
      setLoading((prevState) => ({ ...prevState, create: false }))
      return
    }

    let payload
    let action

    if (dataStock?.sellerPhone) {
      payload = {
        userId: ownerData?.userId,
        item: [
          {
            id: dataStock?.itemId,
            nameItem: dataStock?.nameItem,
            unit: dataStock?.unit,
            amount: dataStock?.amount,
            price: dataStock?.unitValue,
          },
        ],
        order: {
          note: dataStock?.note,
          landplottingId: dataStock?.landplottingId,
          recordTime: dataStock?.recordTime ?? Date.now(),
          timeZone: 7,
        },
        buyer: { phoneNumber: ownerData?.phoneNumber },
        seller: { phoneNumber: dataStock?.sellerPhone },
        latitude: position?.latitude ?? profile?.latitude,
        longitude: position?.longitude ?? profile?.longitude,
        ...(selectedProject?.value && { projectId: selectedProject.value }),
      }
      action = createStockTrx
    } else {
      payload = {
        ownerCode: dataStock?.ownerCode !== '' ? dataStock?.ownerCode : null,
        amount: dataStock?.amount,
        unitValue: dataStock?.unitValue,
        description: dataStock?.description,
        images: [{ url: dataStock?.linkFoto }],
        itemId: dataStock?.itemId,
        latitude: position?.latitude ?? profile?.latitude,
        longitude: position?.longitude ?? profile?.longitude,
        unit: dataStock?.unit,
        warehouseId: dataStock?.warehouseId || defaultWarehouse?.id,
        ...(dataStock?.bundle && { bundle: Number(dataStock.bundle) }),
        ...(dataStock?.recordTime && { recordTime: dataStock?.recordTime }),
        ...(dataStock?.landplottingId && {
          landplottingId: dataStock?.landplottingId,
        }),
        ...(selectedProject?.value && { projectId: selectedProject.value }), // ADD PROJECT ID
      }
      action = createStock
    }

    if (locationBlocked) {
      alert('Please enable location services to create inventory.')
      setLoading((prevState) => ({ ...prevState, create: false }))
      return
    }

    dispatch(action(payload))
      .then((res) => {
        if (res?.error) throw res

        if (id && !dataStock?.sellerPhone) {
          onAddInventoryToGroup(res?.payload?.id)
        }
        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        setFetchSummary(true)

        enqueueSnackbar(
          dataStock?.sellerPhone
            ? 'Hasil pencatatan dapat dilihat pada daftar transaksi'
            : 'Stok baru berhasil ditambahkan',
          { variant: 'success' },
        )

        handleResetDataStock()
        const defaultUnitAfterCreate = itemUnitList?.find(
          (u) => u?.title?.toLowerCase() === 'kg',
        )
        setSelectedUnit(
          defaultUnitAfterCreate
            ? {
                value: defaultUnitAfterCreate.title?.toLowerCase(),
                label: defaultUnitAfterCreate.title,
                ...defaultUnitAfterCreate,
              }
            : { value: 'kg', label: 'Kg' },
        )
        setSelectedStock({})
        if (type !== 'repeat') {
          onShowHideModal('add', false)
        }
        setLoading((prevState) => ({ ...prevState, create: false }))
      })
      .catch((err) => {
        setLoading((prevState) => ({ ...prevState, create: false }))
        enqueueSnackbar(err?.payload, { variant: 'error' })
      })
  }

  const onUpdateStock = async (selectedProject, selectedReason) => {
    setLoading((prevState) => ({ ...prevState, update: true }))
    const result = await getMyLocation()
    if (result?.locationBlocked) {
      enqueueSnackbar('Harap aktifkan lokasi pada perangkat Anda.', {
        variant: 'error',
      })
      setLoading((prevState) => ({ ...prevState, update: false }))
      return
    }

    const normalizeAmount = (value) => {
      if (value === undefined || value === null || value === '') return 0

      let val = String(value).replace(',', '.')
      const num = parseFloat(val)
      return isNaN(num) ? 0 : num
    }

    const payload = {
      ownerCode:
        selectedStock?.ownerCode !== '' ? selectedStock?.ownerCode : null,
      amount: normalizeAmount(selectedStock?.amount),
      unitValue: selectedStock?.unitValue,
      description: selectedStock?.description,
      images: [{ url: selectedStock?.linkFoto }],
      itemId: selectedStock?.itemId,
      latitude: position?.latitude,
      longitude: position?.longitude,
      unit: selectedStock?.unit,
      inventoryId: selectedStock?.id,
      projectId: selectedProject?.value || null,
      ...(selectedStock?.bundle !== undefined &&
        selectedStock?.bundle !== null &&
        selectedStock?.bundle !== '' && {
          bundle: Number(selectedStock.bundle),
        }),
      ...(selectedReason ? { action: selectedReason.value } : {}),
    }

    if (locationBlocked) {
      alert('Please enable location services to create stock.')
      return
    }

    if (isTransform) {
      const parseAmount = (value) => {
        if (value === null || value === undefined || value === '') return 0
        if (typeof value === 'number') return value

        let str = String(value).trim()
        if (str.includes(',')) {
          str = str.replace(/\./g, '')
          str = str.replace(/,/g, '.')
        } else if (str.includes('.')) {
          const parts = str.split('.')

          if (parts.length === 2) {
            if (parts[1].length === 3) {
              str = parts.join('')
            } else {
              str = parts.join('.')
            }
          } else if (parts.length > 2) {
            const last = parts[parts.length - 1]
            if (last.length === 3) {
              str = parts.join('')
            } else {
              str = parts.slice(0, -1).join('') + '.' + last
            }
          }
        }

        const result = parseFloat(str)
        return isNaN(result) ? 0 : result
      }

      const newPayload = {
        inventoryId: selectedStock?.id,
        arrNew: transformItems.map((item) => ({
          ownerCode: item?.ownerCode ?? selectedStock?.ownerCode,
          amount: parseAmount(
            item.amount || displayAmount || selectedStock?.amount,
          ),
          itemId: item.itemId || selectedStock?.itemId,
          description: notes || selectedStock?.description,
          unit: selectedStock?.unit || item.unit,
          unitValue: selectedStock?.unitValue,
          ...((item?.bundle || selectedStock?.bundle) && {
            bundle: Number(item?.bundle || selectedStock?.bundle),
          }),
        })),
        notes: notes || selectedStock?.description || '',
        latitude: position?.latitude,
        longitude: position?.longitude,
        projectId: selectedProject?.value || null,
        action: selectedReason?.value || null,
      }
      dispatch(splitToManyInventory(newPayload)).unwrap()
        .then((res) => {
          fetchInventory(
            currentPage,
            size,
            searchInventory,
            selectedSort?.type,
            selectedSort?.mode,
            defaultWarehouse?.id,
            id,
            dateFilter?.from,
            dateFilter?.to,
            statusFilter?.value,
            projectFilterRef.current?.value || null,
          )
          setFetchSummary(true)
          onShowHideModal('edit', false)
          setLoading((prevState) => ({ ...prevState, update: false }))
          if (isTransform) {
            enqueueSnackbar('Inventory berhasil di proses', {
              variant: 'success',
            })
            onHandleResetNewTransform()
          }
          setIsTransform(false)
        })
        .catch((err) => {
          enqueueSnackbar(err ?? 'Gagal memproses inventori', {
            variant: 'error',
          })
          setLoading((prevState) => ({ ...prevState, update: false }))
          setIsTransform(false)
        })
    } else if (selectedEditAction !== 'general') {
      dispatch(updateInventory(payload))
        .then((res) => {
          fetchInventory(
            currentPage,
            size,
            searchInventory,
            selectedSort?.type,
            selectedSort?.mode,
            defaultWarehouse?.id,
            id,
            dateFilter?.from,
            dateFilter?.to,
            statusFilter?.value,
            projectFilterRef.current?.value || null,
          )
          setFetchSummary(true)
          onShowHideModal('edit', false)
          setSelectedStock((prevState) => ({
            ...prevState,
            ownerCode: selectedStock?.ownerCode,
            amount: selectedStock?.amount,
            unitValue: selectedStock?.unitValue,
            unit: selectedStock?.unit,
            bundle: selectedStock?.bundle,
            item: { ...prevState?.item, linkFoto: selectedStock?.linkFoto },
            description: selectedStock?.description,
          }))
          setLoading((prevState) => ({ ...prevState, update: false }))
        })
        .catch(() => {
          setLoading((prevState) => ({ ...prevState, update: false }))
        })
    } else {
      dispatch(transformInventory(payload))
        .then((res) => {
          if (res?.error) {
            enqueueSnackbar(res?.payload, {
              variant: 'error',
            })
          }
          fetchInventory(
            currentPage,
            size,
            searchInventory,
            selectedSort?.type,
            selectedSort?.mode,
            defaultWarehouse?.id,
            id,
          )
          setFetchSummary(true)
          onShowHideModal('edit', false)
          setLoading((prevState) => ({ ...prevState, update: false }))
          if (isTransform) {
            enqueueSnackbar('Inventory berhasil di proses', {
              variant: 'success',
            })
            onHandleResetNewTransform()
          }
        })
        .catch(() => {
          setLoading((prevState) => ({ ...prevState, update: false }))
        })
    }
  }

  const onSplitStock = async () => {
    setLoading((prevState) => ({ ...prevState, split: true }))
    const result = await getMyLocation()
    if (result?.locationBlocked) {
      enqueueSnackbar('Harap aktifkan lokasi pada perangkat Anda.', {
        variant: 'error',
      })
      setLoading((prevState) => ({ ...prevState, split: false }))
      return
    }
    let payload = {
      arrNew: splitItems?.map((item) => ({
        amount:
          typeof item?.amount === 'string'
            ? parseFloat(item?.amount?.replace(',', '.')) || 0
            : item?.amount,
        itemId: item?.itemId,
        desc: item?.desc,
        unit: item?.unit,
        ownerCode: item?.ownerCode,
        ...(item?.bundle && { bundle: Number(item.bundle) }),
      })),
      latitude: position?.latitude,
      longitude: position?.longitude,
      inventoryId: selectedStock?.id,
    }
    if (locationBlocked) {
      alert('Please enable location services to create stock.')
      return
    }
    dispatch(splitInventory(payload))
      .then((res) => {
        if (res?.error?.message === 'Rejected') {
          throw res?.error?.message
        }
        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        setFetchSummary(true)
        onShowHideModal('split', false)
        onShowHideModal('processSplit', false)
        setSplitItems([])
        setSelectedStock({})
        enqueueSnackbar('Inventori berhasil dipisah.', { variant: 'success' })
        setLoading((prevState) => ({ ...prevState, split: false }))
      })
      .catch(() => {
        enqueueSnackbar('Stok gagal dipisah.', { variant: 'error' })
        setLoading((prevState) => ({ ...prevState, split: false }))
      })
  }

  const onMergeStock = async (selectedProject) => {
    setLoading((prevState) => ({ ...prevState, merge: true }))
    const result = await getMyLocation()
    if (result?.locationBlocked) {
      enqueueSnackbar('Harap aktifkan lokasi pada perangkat Anda.', {
        variant: 'error',
      })
      setLoading((prevState) => ({ ...prevState, merge: false }))
      return
    }
    let payload = {
      arrInventoryIds: [
        selectedStock?.id,
        ...selectedInventoryList.map((item) =>
          typeof item === 'object' && item?.id ? item.id : item,
        ),
      ]
        .filter((item) => Boolean(item))
        .filter((item, index, self) => self.indexOf(item) === index),
      description: dataStock?.description,
      images: [{ url: dataStock?.linkFoto }],
      latitude: position?.latitude,
      longitude: position?.longitude,
      newAmount: Number(dataStock?.amount),
      unit: selectedStock?.unit || dataStock?.unit,
      newItemId: dataStock?.itemId,
      ownerCode: dataStock?.ownerCode ?? null,
      ...(dataStock?.bundle && { bundle: Number(dataStock.bundle) }),
      ...(selectedProject?.value && { projectId: selectedProject.value }), // ADD PROJECT ID
    }

    if (locationBlocked) {
      alert('Please enable location services to create stock.')
      return
    }
    dispatch(mergeInventory(payload))
      .then((res) => {
        if (res?.error?.message) {
          throw res?.payload?.data?.message || res?.error?.message
        }

        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        setFetchSummary(true)
        onShowHideModal('add', false)
        onShowHideModal('merge', false)
        onShowHideModal('addStock', false)
        onShowHideModal('mergeInventory', false)
        setSelectedInventoryList([])
        toggleClearRows()
        handleResetDataStock()
        setSelectedStock({})
        setLoading((prevState) => ({ ...prevState, merge: false }))
        enqueueSnackbar('Inventori berhasil digabungkan.', {
          variant: 'success',
        })
      })
      .catch((err) => {
        enqueueSnackbar(err, {
          variant: 'error',
        })
        setLoading((prevState) => ({ ...prevState, merge: false }))
      })
  }

  const handleRemoveStock = async (payload) => {
    let action = 'DELETE'
    try {
      const { note = '', buyerName, price = 0 } = payload
      action = payload.action || 'DELETE'
      const arrInventoryIds =
        selectedDataRemove?.length > 0
          ? selectedDataRemove.map((data) => data.id)
          : selectedInventoryList?.map((data) => data.id) || []

      const requestPayload = {
        arrInventoryIds,
        note,
        action,
        ...(action === 'SELL' && { buyerName, price }),
        ...(payload?.arrPartialAmounts &&
          selectedDataRemove?.length === 1 && {
            arrPartialAmounts: payload.arrPartialAmounts,
          }),
        ...(payload?.subaction && { subaction: payload.subaction }),
      }

      await dispatch(deleteInventory(requestPayload)).unwrap()
      enqueueSnackbar('Inventori berhasil dihapus.', { variant: 'success' })

      fetchInventory(
        currentPage,
        size,
        searchInventory,
        selectedSort?.type,
        selectedSort?.mode,
        defaultWarehouse?.id,
        id,
        dateFilter?.from,
        dateFilter?.to,
        statusFilter?.value,
        projectFilterRef.current?.value || null,
      )
      setFetchSummary(true)

      onShowHideModal('confirmRemove', false)
      onShowHideModal('confirmRemoveMultiple', false)
      setSelectedInventoryList([])
      toggleClearRows()
      setSelectedDataRemove([])
      setSelectedStock({})
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Terjadi kesalahan saat menghapus inventori.', {
        variant: 'error',
      })
    } finally {
      setLoading((prevState) => ({ ...prevState, removeStock: false }))
    }
  }
  // END NEW REMOVE INVENTORY

  const onRemoveStock = async (id) => {
    if (loading?.removeStock) return
    setLoading((prevState) => ({ ...prevState, removeStock: true }))
    const result = await getMyLocation()
    if (result?.locationBlocked) {
      enqueueSnackbar('Harap aktifkan lokasi pada perangkat Anda.', {
        variant: 'error',
      })
      setLoading((prevState) => ({ ...prevState, removeStock: false }))
      return
    }
    let payload = {
      arrInventoryIds: selectedInventoryList.map((e) => e?.id),
    }
    if (typeof id === 'number') {
      payload['arrInventoryIds'] = [id]
    }
    if (id?.length) {
      payload['arrInventoryIds'] = id
    }
    if (locationBlocked) {
      alert('Please enable location services to create stock.')
      return
    }
    dispatch(removeInventory(payload))
      .then((res) => {
        fetchInventory(
          currentPage,
          size,
          searchInventory,
          selectedSort?.type,
          selectedSort?.mode,
          defaultWarehouse?.id,
          id,
          dateFilter?.from,
          dateFilter?.to,
          statusFilter?.value,
          projectFilterRef.current?.value || null,
        )
        setFetchSummary(true)
        onShowHideModal('remove', false)
        onShowHideModal('confirmRemove', false)
        onShowHideModal('confirmRemoveMultiple', false)
        onShowHideModal('detail', false)
        setSelectedInventoryList([])
        setSelectedStock({})
        enqueueSnackbar('Inventori berhasil dihapus.', { variant: 'success' })
        setLoading((prevState) => ({ ...prevState, removeStock: false }))
      })
      .catch(() => {
        setLoading((prevState) => ({ ...prevState, removeStock: false }))
      })
  }

  // HANDLE CHANGE VALUE

  const onChangeValueStock = (key, value, index) => {
    const totalInitial = parseFloat(selectedStock?.amount.replace(',', '.'))
    let newItems = [...splitItems]

    if (key === 'amount') {
      let processedValue =
        value !== null && value !== undefined
          ? value.toString().replace(/\./g, ',').trim()
          : ''

      processedValue = processedValue.replace(/[^0-9,]/g, '')

      const parts = processedValue.split(',')
      if (parts.length > 2) {
        processedValue = parts[0] + ',' + parts.slice(1).join('')
      }
      newItems[index] = {
        ...newItems[index],
        [key]: processedValue,
      }

      let numericValue = parseFloat(processedValue.replace(',', '.'))
      if (
        isNaN(numericValue) ||
        processedValue === '' ||
        processedValue === ','
      ) {
        numericValue = 0
      }

      const lockedItems = newItems.filter(
        (item, i) => i !== index && item.locked,
      )
      const totalLockedAmount = lockedItems.reduce(
        (sum, item) =>
          sum + parseFloat(String(item.amount || '0').replace(',', '.')),
        0,
      )

      let remaining = totalInitial - numericValue - totalLockedAmount
      if (isNaN(remaining)) remaining = 0

      const editableIndexes = newItems
        .map((item, i) => ({ item, i }))
        .filter(({ i, item }) => i !== index && !item.locked)

      const editableCount = editableIndexes.length

      if (editableCount > 0) {
        if (remaining <= 0) {
          editableIndexes.forEach(({ i }) => {
            newItems[i] = {
              ...newItems[i],
              amount: '0',
            }
          })
        } else {
          const base = Math.floor(remaining / editableCount)
          const remainder = remaining % editableCount

          editableIndexes.forEach(({ i }, uIdx) => {
            let amt = base
            if (uIdx < Math.floor(remainder)) {
              amt = base + 1
            } else if (uIdx === Math.floor(remainder) && remainder % 1 > 0) {
              amt = base + (remainder % 1)
            }

            if (amt < 0 || isNaN(amt)) amt = 0

            // simpan sebagai string dengan koma
            newItems[i] = {
              ...newItems[i],
              amount: amt.toString().replace('.', ','), // titik jadi koma
            }
          })
        }
      }
    } else {
      newItems[index] = {
        ...newItems[index],
        [key]: value ?? '',
      }
    }

    setSplitItems(newItems)
  }

  const handleClickOutside = (event) => {
    if (
      actionMenuRef.current &&
      !actionMenuRef.current.contains(event.target)
    ) {
      onSelectStockMenu(selectedStock)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault()
      if (!isDetail) {
        if (page > 0) {
          setPage((prevPage) => prevPage - 1)

          setShowModal((prevState) => {
            const updatedModalState = { ...prevState }
            Object.keys(updatedModalState).forEach((key) => {
              updatedModalState[key] = false
            })
            return updatedModalState
          })
        }
      } else {
        if (breadCrumbsData && breadCrumbsData.length > 1) {
          const prevCrumb = breadCrumbsData[breadCrumbsData.length - 2]

          if (prevCrumb?.id && prevCrumb?.label) {
            onManageBreadCrumb({
              label: prevCrumb.label,
              id: prevCrumb.id,
            })
          }
        }

        setShowModal((prevState) => {
          const updatedModalState = { ...prevState }
          Object.keys(updatedModalState).forEach((key) => {
            updatedModalState[key] = false
          })
          return updatedModalState
        })
      }
    }

    window.addEventListener('popstate', handleBackButton)
    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [page, isDetail, breadCrumbsData]) // ✅ depend on full breadCrumbsData, not just length

  useEffect(() => {
    if (!isDetail) {
      if (page >= 0) {
        window.history.pushState({ page }, '', ``)
      }
    }
  }, [page])

  const activeFilterCount = useMemo(() => {
    let count = 0
    if (dateFilter?.from && dateFilter?.to) count++
    if (statusFilter?.value && statusFilter?.value !== '') count++
    if (projectFilter?.value) count++
    if (searchInventory && searchInventory !== '') count++
    return count
  }, [dateFilter, statusFilter, projectFilter, searchInventory])

  const handleResetFilter = () => {
    setDateFilter({ from: null, to: null })
    setProjectFilter(null)
    setStatusFilter({ value: '', label: 'Semua Keterangan' })
    setSearchInventory('')
    fetchInventory(
      0,
      size,
      '',
      selectedSort?.type,
      selectedSort?.mode,
      defaultWarehouse?.id,
      id,
      null,
      null,
      '',
      null,
    )
  }

  const onRemoveGroup = async (groupIds) => {
    try {
      const obj = {
        groupIds,
      }
      const res = await dispatch(removePacking(obj))
      if (res?.error) {
        throw res
      }
      setIsFetch('inventory')
      onShowHideModal('confirmRemoveMultiple', false)
      setSelectedGroupInventory([])
      toggleClearRowsGroup()
      enqueueSnackbar(`Inventori / grup di label berhasil dihapus.`, {
        variant: 'success',
      })
    } catch {
      // Error removing inventory from group
    } finally {
      setLoading(false)
    }
  }

  const handleOpenMoveInventoryModal = (list = selectedInventoryList) => {
    const items = Array.isArray(list) ? list : [list]
    if (!items?.length) return

    const hasPending = items.some((item) => item?.pending || item?.isPending)
    if (hasPending) {
      enqueueSnackbar(
        'Inventori yang sedang dalam proses transfer tidak dapat dipindahkan.',
        { variant: 'warning' },
      )
      return
    }

    setIsSubGroup(false)
    setSelectedInventoryList(items)
    setSelectedFolder({})
    setIdsGroup(defaultWarehouse?.id ? [defaultWarehouse] : [])
    fetchGroupInventory(
      0,
      9999,
      '',
      selectedSortGroup?.type || 'updatedAt',
      selectedSortGroup?.mode || 'desc',
      defaultWarehouse?.id,
      '',
      'folder',
    )
    onShowHideModal('addItemToGroup', true)
  }

  const onAddInventoryToGroup = async (inventoryIds = [], groupId) => {
    setLoading((prevState) => ({ ...prevState, addStockToGroup: true }))

    try {
      const obj = {
        id: groupId ? groupId : id,
        addedInventoryIds: Array.isArray(inventoryIds)
          ? inventoryIds?.map((e) => e?.id)
          : [inventoryIds],
      }
      const res = await dispatch(packingAddStock(obj))
      if (res?.error) {
        throw res
      } else {
        setIsFetch('all')
        if (isDetail && id) {
          dispatch(getPackingDetail({ page: 0, id }))
        }
        enqueueSnackbar(
          isDetail
            ? `${inventoryIds.length ?? ''} Inventori berhasil dipindahkan ke grup`
            : `${inventoryIds.length ?? ''} Inventori berhasil ditambahkan ke grup`,
          { variant: 'success' },
        )
        setSelectedInventoryList([])
        toggleClearRows()
      }
    } catch (error) {
      enqueueSnackbar(
        isDetail
          ? `${inventoryIds.length ?? ''} Inventori gagal dipindahkan ke grup`
          : `${inventoryIds.length ?? ''} Inventori gagal ditambahkan ke grup`,
        { variant: 'error' },
      )
    } finally {
      setLoading((prevState) => ({ ...prevState, addStockToGroup: false }))
      onShowHideModal('detail', false)
      setSelectedFolder({})
    }
  }

  const onCreateGroupForGroup = async () => {
    const payload = {
      // ...(!isExist && {
      //   label: label,
      // }),
      // ...(isExist && {
      id: selectedFolder?.id,
      // }),
      addedGroupIds: selectedGroupInventory?.map((e) => e?.id),
    }

    try {
      const res = await dispatch(
        manageGroupForGroup({
          actionType: 'create',
          payload,
          id: selectedFolder?.id,
        }),
      ).unwrap()
      if (res?.error) {
        throw res
      }
      setSelectedGroupInventory([])
      setIsFetch('all')
      // onClose()
      enqueueSnackbar(
        selectedGroupInventory?.length > 0
          ? `${selectedGroupInventory?.length} grup berhasil di${actionType?.toLowerCase()} grup`
          : 'Grup berhasil dibuat',
        {
          variant: 'success',
        },
      )
      setSelectedInventoryList([])
      toggleClearRows()
    } catch (err) {
      enqueueSnackbar(err ?? 'Terjadi kesalahan saat membuat grup', {
        variant: 'error',
      })
    }
  }

  const handleJualList = (list) => {
    const groups = {}
    list.forEach((invRaw) => {
      const inv = { ...invRaw }
      const itemId = inv.itemId || inv.item?.id || ''
      const unitVal = inv.unit?.value || inv.unit || ''
      const lotCode =
        inv.lotCode ||
        (inv.lots && inv.lots.length > 0
          ? inv.lots.reduce((latest, current) => {
              if (!latest?.data?.createdAt) return current
              return new Date(current.data.createdAt) >
                new Date(latest.data.createdAt)
                ? current
                : latest
            }, inv.lots[0])?.data?.lotCode
          : null)

      // Attach derived lotCode back to inventory for consistent display
      if (!inv.lotCode && lotCode) {
        inv.lotCode = lotCode
      }

      const invSourceGroupName =
        inv.sourceGroupName ||
        inv.groupName ||
        inv.group?.nameItem ||
        inv.group?.name ||
        inv.group?.label ||
        null
      const key = `${itemId}-${String(unitVal).toLowerCase()}`

      if (!groups[key]) {
        groups[key] = {
          ...inv,
          unit: unitVal,
          sourceGroupName: invSourceGroupName,
          totalAmount: 0,
          inventoryIds: [],
          inventories: [],
        }
      }
      // Ensure the individual inventory item also has the sourceGroupName
      if (!inv.sourceGroupName && invSourceGroupName) {
        inv.sourceGroupName = invSourceGroupName
      }

      const amountVal = parseFloat(String(inv.amount || 0).replace(',', '.'))
      groups[key].totalAmount += isNaN(amountVal) ? 0 : amountVal
      groups[key].inventoryIds.push(inv.id)
      groups[key].inventories.push(inv)
    })

    const groupedItems = Object.values(groups).map((group, idx) => {
      const amountStr = group.totalAmount
        .toFixed(2)
        .replace('.', ',')
        .replace(/,00$/, '')
      return {
        orderItemId: idx + 1,
        inventoryId: group.inventoryIds[0],
        inventoryIds: group.inventoryIds,
        originalAmount: amountStr,
        amount: amountStr,
        isFromManageStock: true,
        sourceGroupName: group.sourceGroupName,
        itemDetail: {
          inventoryId: group.inventoryIds[0],
          inventoryIds: group.inventoryIds,
          inventories: group.inventories,
          sourceGroupName: group.sourceGroupName,
        },
        nameItem: group.item?.nameItem || group.label || '',
        itemId: group.itemId || group.item?.id || '',
        imageUrl: group.item?.imageUrl || '',
        SKU: group.item?.SKU || group?.SKU || '',
        unit: {
          label: group.unit,
          value: group.unit,
        },
        price: group.price || '',
      }
    })

    navigate('/sell-commodity', {
      state: {
        prefillOrders: {
          item: groupedItems,
          type: 'SELL',
        },
        prefillAddItemCount: groupedItems.map((_, i) => i + 1),
        isInventory: groupedItems.map(() => true),
      },
    })
  }

  const handleJualGroup = async (groupsInput = null) => {
    const groupsToProcess = Array.isArray(groupsInput)
      ? groupsInput
      : selectedGroupInventory
    if (!groupsToProcess?.length) return

    isCollectingRef.current = true
    setIsCollectingGroup(true)
    setCollectingCurrent(0)
    // Estimate 2 tasks per group (inv fetch + group fetch)
    let totalTasks = groupsToProcess.length * 2
    let completedTasks = 0
    setCollectingTotal(totalTasks)

    try {
      const allCollectedItems = []
      const processedGroupIds = new Set()

      const recursiveCollect = async (groupId, groupName) => {
        if (!isCollectingRef.current) return
        if (processedGroupIds.has(groupId)) return
        processedGroupIds.add(groupId)

        // 1. Fetch inventories in this group
        const invRes = await dispatch(
          getAllInventory({
            groupId: groupId,
            size: 9999,
            projectId: projectFilterRef.current?.value || null,
          }),
        ).unwrap()

        if (!isCollectingRef.current) return

        completedTasks++
        setCollectingCurrent(completedTasks)

        if (invRes?.items?.length > 0) {
          // Attach group name to each item to preserve origin info
          const itemsWithGroup = invRes.items.map((item) => ({
            ...item,
            sourceGroupName: groupName,
          }))
          allCollectedItems.push(...itemsWithGroup)
        }

        // 2. Fetch sub-groups in this group
        const groupsRes = await dispatch(
          fetchInventoryGroups({
            parentGroupId: groupId,
            size: 9999,
          }),
        ).unwrap()

        if (!isCollectingRef.current) return

        completedTasks++
        setCollectingCurrent(completedTasks)

        if (groupsRes?.items?.length > 0) {
          // Add 2 tasks for each sub-group found
          totalTasks += groupsRes.items.length * 2
          setCollectingTotal(totalTasks)

          for (const subGroup of groupsRes.items) {
            if (!isCollectingRef.current) return
            const subGroupName =
              subGroup.nameItem || subGroup.name || subGroup.label || groupName
            await recursiveCollect(subGroup.id, subGroupName)
          }
        }
      }

      for (const group of groupsToProcess) {
        if (!isCollectingRef.current) break
        const initialGroupName =
          group.label || group.nameItem || group.name || group.title || ''
        await recursiveCollect(group.id, initialGroupName)
      }

      if (!isCollectingRef.current) {
        setIsCollectingGroup(false)
        return
      }

      // Filter out duplicate items
      const uniqueItems = Array.from(
        new Map(allCollectedItems.map((item) => [item.id, item])).values(),
      )

      if (uniqueItems.length === 0) {
        enqueueSnackbar('Grup ini tidak memiliki inventori.', {
          variant: 'warning',
        })
        return
      }

      handleJualList(uniqueItems)
    } catch (err) {
      console.error('Error in handleJualGroup:', err)
      enqueueSnackbar('Gagal mengambil data inventori grup.', {
        variant: 'error',
      })
    } finally {
      setIsCollectingGroup(false)
    }
  }

  const handleTransferInventory = (list) => {
    if (!canTransfer) {
      enqueueSnackbar('Anda tidak memiliki akses untuk transfer inventori.', {
        variant: 'error',
      })
      return
    }
    const items = Array.isArray(list) ? list : [list]
    if (!items.length) {
      enqueueSnackbar('Pilih inventori yang akan dipindahkan.', {
        variant: 'warning',
      })
      return
    }

    // Validation: check pending transfer
    const hasPending = items.some((item) => item?.pending)
    if (hasPending) {
      enqueueSnackbar(
        'Beberapa inventori yang dipilih sedang dalam proses transfer.',
        { variant: 'warning' },
      )
      return
    }

    // Validation: warehouse consistency
    const getWarehouseId = (item) => {
      const warehouseId =
        item?.warehouse?.id ??
        item?.warehouse?.value ??
        item?.warehouseId
      return warehouseId === 'null' ? null : warehouseId
    }
    const firstWarehouseId = getWarehouseId(items[0])
    const originWarehouse = firstWarehouseId
      ? items[0]?.warehouse?.id || items[0]?.warehouse?.value
        ? items[0].warehouse
        : warehouses?.newData?.find(
            (warehouse) =>
              String(warehouse.id ?? warehouse.value) ===
              String(firstWarehouseId),
          ) ||
          (String(defaultWarehouse?.id) === String(firstWarehouseId)
            ? defaultWarehouse
            : {
                ...items[0]?.warehouse,
                id: firstWarehouseId,
                value: firstWarehouseId,
                name:
                  items[0]?.warehouse?.name ||
                  items[0]?.warehouseName ||
                  defaultWarehouse?.name,
                label:
                  items[0]?.warehouse?.label ||
                  items[0]?.warehouse?.name ||
                  items[0]?.warehouseName ||
                  defaultWarehouse?.label ||
                  defaultWarehouse?.name,
              })
      : items[0]?.warehouseId === 'null'
        ? null
        : defaultWarehouse || null

    const isDiffWarehouse = items.some((item) => {
      const wId = getWarehouseId(item) ?? defaultWarehouse?.id
      return (
        originWarehouse?.id &&
        wId &&
        Number(wId) !== Number(originWarehouse.id)
      )
    })

    if (isDiffWarehouse) {
      enqueueSnackbar(
        'Hanya dapat memindahkan inventori dari gudang yang sama.',
        { variant: 'warning' },
      )
      return
    }

    setTransferModalData({
      type: 'INVENTORY',
      items,
      originWarehouse:
        originWarehouse || {
          id: null,
          value: 'null',
          name: 'Tanpa Gudang',
          label: 'Tanpa Gudang',
        },
    })
    setShowModalTransfer(true)
  }

  const handleTransferGroup = async (groupsInput = null) => {
    if (!canTransfer) {
      enqueueSnackbar(
        'Anda tidak memiliki akses untuk transfer grup inventori.',
        {
          variant: 'error',
        },
      )
      return
    }
    const groupsToProcess = Array.isArray(groupsInput)
      ? groupsInput
      : selectedGroupInventory
    if (!groupsToProcess?.length) {
      enqueueSnackbar('Pilih grup yang akan dipindahkan.', {
        variant: 'warning',
      })
      return
    }

    // Validation: check pending transfer
    const hasPending = groupsToProcess.some((g) => g?.isPending)
    if (hasPending) {
      enqueueSnackbar(
        'Beberapa grup yang dipilih sedang dalam proses transfer.',
        { variant: 'warning' },
      )
      return
    }

    // Validation: check empty group
    const emptyGroups = groupsToProcess.filter(
      (g) => g?.totalInventory === 0,
    )
    if (
      emptyGroups.length === groupsToProcess.length &&
      groupsToProcess.length > 0
    ) {
      enqueueSnackbar('Grup yang dipilih tidak memiliki inventori.', {
        variant: 'warning',
      })
      return
    }

    const originWarehouse =
      groupsToProcess[0]?.warehouse ||
      defaultWarehouse ||
      (groupsToProcess[0]?.warehouseId
        ? warehouses?.newData?.find(
            (w) => Number(w.id) === Number(groupsToProcess[0].warehouseId),
          )
        : null)

    const isDiffWarehouse = groupsToProcess.some((group) => {
      const wId =
        group?.warehouse?.id || group?.warehouseId || defaultWarehouse?.id
      return (
        originWarehouse?.id &&
        wId &&
        Number(wId) !== Number(originWarehouse.id)
      )
    })

    if (isDiffWarehouse) {
      enqueueSnackbar(
        'Hanya dapat memindahkan grup inventori dari gudang yang sama.',
        { variant: 'warning' },
      )
      return
    }

    setTransferModalData({
      type: 'GROUP',
      groups: groupsToProcess,
      originWarehouse,
    })
    setShowModalTransfer(true)
  }

  const handleConfirmTransfer = () => {
    if (!transferModalData) return
    setShowModalTransfer(false)

    if (transferModalData.type === 'INVENTORY') {
      navigate(URL_FORM_TRANSFER_INVENTORY, {
        state: {
          fromWarehouse: transferModalData.originWarehouse,
          transferItems: transferModalData.items.map((item) => ({
            id: item.id,
            amount: item.amount,
            transferAmount: item.amount,
            unit: item.unit || item.item?.unit,
            item: item.item,
            ownerCode: item.ownerCode,
            lots: item.lots,
            isPacking: false,
          })),
          type: 'INVENTORY',
        },
      })
    } else {
      navigate(URL_FORM_TRANSFER_INVENTORY, {
        state: {
          fromWarehouse: transferModalData.originWarehouse,
          transferItems: transferModalData.groups.map((grp) => ({
            id: grp.id,
            label: grp.label || grp.name || grp.nameItem,
            totalInventory: grp.totalInventory,
            totalAmount: grp.totalAmount,
            isPacking: true,
          })),
          type: 'GROUP',
        },
      })
    }
  }

  const WORDING_TOOLTIP =
    'Aksi tidak bisa dilakukan karena inventori ini sedang dalam proses transfer'

  const toggleRow = (row) => {
    if (row?.pending) return

    setSelectedInventoryList((prev) => {
      const selectedIds = new Set(prev.map((x) => x.id))
      return selectedIds.has(row.id)
        ? prev.filter((r) => r.id !== row.id)
        : [...prev, row]
    })
    setSelectedDataRemove((prev) => {
      const selectedIds = new Set(prev.map((x) => x.id))
      return selectedIds.has(row.id)
        ? prev.filter((r) => r.id !== row.id)
        : [...prev, row]
    })
  }

  const toggleAll = () => {
    const selectableRows = inventoryList.filter((item) => !item.pending)

    const allSelected = selectableRows.every((item) => selectedIds.has(item.id))

    if (allSelected) {
      setSelectedDataRemove((prev) =>
        prev.filter((item) => !selectableRows.some((i) => i.id === item.id)),
      )
      setSelectedInventoryList((prev) =>
        prev.filter((item) => !selectableRows.some((i) => i.id === item.id)),
      )
    } else {
      const newSelections = selectableRows.filter(
        (item) => !selectedIds.has(item.id),
      )
      setSelectedDataRemove((prev) => [...prev, ...newSelections])
      setSelectedInventoryList((prev) => [...prev, ...newSelections])
    }
  }

  const selectedIds = useMemo(
    () => new Set(selectedInventoryList.map((x) => x.id)),
    [selectedInventoryList],
  )

  const allSelected = inventoryList
    ?.filter((item) => !item.pending)
    ?.every((item) => selectedIds.has(item.id))

  const someSelected = inventoryList
    ?.filter((item) => !item.pending)
    ?.some((item) => selectedIds.has(item.id))

  const getCheckboxIcon = () => {
    if (allSelected)
      return (
        <SvgIcon
          size={25}
          name={'checkbox-active'}
          color={colors.primary[400]}
        />
      )
    if (someSelected) return <MinusSquare size={16} />
    return <SvgIcon size={25} name={'checkbox'} />
  }

  const checkboxColumn = {
    name: (
      <div onClick={toggleAll} style={{ cursor: 'pointer' }}>
        {getCheckboxIcon()}
      </div>
    ),
    cell: (row) => {
      const isSelected = selectedIds.has(row.id)
      const isDisabled = row?.pending

      return (
        <div
          onClick={() => {
            if (!isDisabled) toggleRow(row)
          }}
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.6 : 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {isDisabled ? (
            <SvgIcon size={20} name={'checkbox'} color={colors.neutral[400]} />
          ) : isSelected ? (
            <SvgIcon
              size={20}
              name={'checkbox-active'}
              color={colors.primary[400]}
            />
          ) : (
            <SvgIcon size={20} name={'checkbox'} />
          )}
        </div>
      )
    },
    width: '60px',
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    skipExport: true,
  }
  const renderMobileCard = (row, index) => {
    const isPending = row?.pending
    const komoditas = row?.item?.nameItem || row?.label
    const amountStr =
      intl.formatNumber(row?.amount || row?.totalInventory, {
        useGrouping: 'always',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }) +
      ' ' +
      (row?.unit || row?.item?.unit)

    return (
      <Card
        key={index}
        className="mb-3 border-0 shadow-sm"
        style={{ borderRadius: '12px', overflow: 'hidden' }}
      >
        <CardBody className="p-0">
          {/* Header Section: Title, Checkbox, and Amount */}
          <div
            className="p-3 d-flex align-items-center"
            style={{
              backgroundColor: '#F9FAFB',
              borderBottom: '1px solid #F2F4F7',
            }}
          >
            <div
              className="me-2 flex-shrink-0"
              onClick={() => {
                if (!isPending) toggleRow(row)
              }}
              style={{
                cursor: isPending ? 'not-allowed' : 'pointer',
                opacity: isPending ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {isPending ? (
                <SvgIcon size={20} name={'checkbox'} color={colors.neutral[400]} />
              ) : selectedIds.has(row.id) ? (
                <SvgIcon
                  size={20}
                  name={'checkbox-active'}
                  color={colors.primary[400]}
                />
              ) : (
                <SvgIcon size={20} name={'checkbox'} />
              )}
            </div>
            <div
              className="fw-bold text-dark text-truncate"
              style={{ fontSize: '0.95rem', flex: 1, paddingRight: '8px' }}
            >
              {komoditas}
            </div>
            <div className="text-end">
              <div
                className="fw-bold text-primary text-nowrap"
                style={{ fontSize: '1.1rem', lineHeight: '1' }}
              >
                {amountStr}
              </div>
            </div>
          </div>

          <div className="p-3">
            {/* Essential Info Only */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                Gudang
              </span>
              <span
                className="fw-medium text-dark text-end text-truncate"
                style={{ fontSize: '0.75rem', maxWidth: '70%' }}
              >
                {row?.warehouse?.name || row?.warehouseName || '-'}
              </span>
            </div>

            <div className="d-flex justify-content-end mb-2">
              {(row?.source?.escrowpaymentId ||
                row?.source?.warehousetransferId) && (
                <span
                  className="badge bg-primary-50 text-primary rounded-pill px-2"
                  style={{
                    fontSize: '0.65rem',
                    cursor: 'pointer',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                  }}
                  onClick={() =>
                    navigate(
                      `${row?.source?.escrowpaymentId ? URL_DETAIL_TRANSACTION : URL_TRANSFER_INVENTORY}/${row?.source?.escrowpaymentId ? row?.source?.escrowpaymentId : row?.source?.warehousetransferId}?type=${row?.source?.escrowpaymentId ? 'BUY' : 'in'}`,
                    )
                  }
                >
                  {row?.source?.escrowpaymentId
                    ? row?.source?.poNumber
                    : `TF/ID/${row?.source?.warehousetransferId}`}
                </span>
              )}
            </div>

            {/* Compact Timestamps: Flex Row Space-Between */}
            <div className="pt-2 border-top">
              <div
                className="text-muted d-flex justify-content-between align-items-center w-100"
                style={{ fontSize: '0.65rem' }}
              >
                <span>Dibuat: {formatDatePMBV2(row?.createdAt)}</span>
                {row?.updatedAt && (
                  <span>Upd: {formatDatePMBV2(row.updatedAt)}</span>
                )}
              </div>
              {isPending && (
                <div
                  className="mt-2 text-warning d-flex align-items-center gap-1 fw-semibold"
                  style={{ fontSize: '0.7rem' }}
                >
                  <span style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#ffc107', display: 'inline-block' }}></span>
                  Inventori sedang dalam proses
                </div>
              )}
            </div>
          </div>

          {/* Action Section: Compact buttons */}
          <div
            className="p-2 border-top d-flex gap-2 justify-content-between align-items-center"
            style={{ backgroundColor: '#F9FAFB' }}
          >
            <div className="d-flex gap-2">
              <CustomButton
                size="sm"
                outline
                className="px-3 py-1"
                onClick={() => {
                  onShowHideModal('qrCode', true, 'general')
                  setSelectedStock({ ...row?.item, ...row })
                }}
              >
                QR
              </CustomButton>
            </div>

            <UncontrolledDropdown>
              <DropdownToggle
                tag="div"
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isPending) fetchLabelItems(row)
                }}
                className="dropdown-toggle-wrapper"
                disabled={isPending}
              >
                <CustomButton
                  outline
                  disabled={isPending}
                  size="sm"
                  className="px-3 py-1"
                  title={isPending ? WORDING_TOOLTIP : undefined}
                  style={{
                    opacity: isPending ? 0.4 : 1,
                    backgroundColor: isPending ? '#F2F4F7' : 'transparent',
                    borderColor: isPending ? '#D0D5DD' : undefined,
                    color: isPending ? '#667085' : undefined,
                    cursor: isPending ? 'not-allowed' : 'pointer'
                  }}
                >
                  Menu
                </CustomButton>
              </DropdownToggle>
              <DropdownMenu container="body">
                {menuStock
                  ?.filter(
                    (el) =>
                      !(el?.editType === 'split' && row?.deleted) &&
                      (el?.modal !== 'transfer' || canTransfer),
                  )
                  ?.map((el, i) => (
                    <DropdownItem
                      key={i}
                      className="mb-2 mt-2 pl-2 button d-flex align-items-center"
                      onClick={() => {
                        if (el?.modal === 'sell') {
                          handleJualList([row])
                          return
                        }
                        if (el?.modal === 'transfer') {
                          handleTransferInventory([row])
                          return
                        }
                        onShowHideModal(
                          el?.modal,
                          true,
                          el?.editType,
                          '',
                          row,
                        )
                        onSelectStockMenu(row)
                        if (el?.modal === 'merge') {
                          fetchGabungInventory(0, row)
                        }
                      }}
                    >
                      {el?.iconType === 'img' ? (
                        <img
                          alt={el?.modal}
                          src={el?.img}
                          style={{ width: 14, height: 14, marginRight: 8 }}
                        />
                      ) : el?.iconType === 'icon' && el?.icon === 'split' ? (
                        <Copy size={14} className="me-2" />
                      ) : el?.icon === 'eye' ? (
                        <Eye size={14} className="me-2" />
                      ) : el?.icon === 'sell' ? (
                        <JualIcon size={14} className="me-2" />
                      ) : el?.icon === 'transfer' ? (
                        <Truck size={14} className="me-2" />
                      ) : (
                        <Trash2 size={14} className="me-2 text-danger" />
                      )}
                      <span style={{ fontSize: '0.8rem' }}>{el?.title}</span>
                    </DropdownItem>
                  ))}

                {row?.lots?.length > 0 && (
                  <DropdownItem
                    className="mb-2 pl-2 button d-flex align-items-center"
                    onClick={() => {
                      onSelectStockMenu(row)
                      setSelectedDataRemove([row])
                      onShowHideModal('editLotId', true)
                    }}
                  >
                    <Edit2 size={14} className="me-2" />
                    <span style={{ fontSize: '0.8rem' }}>Edit Lot ID</span>
                  </DropdownItem>
                )}

                <DropdownItem
                  className="mb-2 pl-2 button d-flex align-items-center"
                  onClick={() => handleJualGroup([row])}
                >
                  <JualIcon size={14} className="me-2" />
                  <span style={{ fontSize: '0.8rem' }}>Jual</span>
                </DropdownItem>

                <DropdownItem
                  className="mb-2 pl-2 button d-flex align-items-center"
                  onClick={() => {
                    setDisplayAmount(row?.amount)
                    onSelectStockMenu(row)
                    setSelectedDataRemove([row])
                    onShowHideModal('confirmRemove', true)
                  }}
                >
                  <Trash2 size={14} className="me-2 text-danger" />
                  <span className="text-danger" style={{ fontSize: '0.8rem' }}>
                    Hapus
                  </span>
                </DropdownItem>

                {isDetail && (
                  <>
                    <DropdownItem
                      className="mb-2 pl-2 button d-flex align-items-center"
                      onClick={() => handleOpenMoveInventoryModal([row])}
                    >
                      <CornerUpRight size={14} className="me-2 text-primary" />
                      <span style={{ fontSize: '0.8rem' }}>
                        Pindahkan ke Grup Lain
                      </span>
                    </DropdownItem>
                    <DropdownItem
                      className="mb-2 pl-2 button d-flex align-items-center"
                      onClick={() => {
                        onSelectStockMenu(row)
                        setSelectedInventoryList([row])
                        onShowHideModal('removeItemPacking', true)
                      }}
                    >
                      <FolderMinus size={14} className="me-2 text-danger" />
                      <span className="text-danger" style={{ fontSize: '0.8rem' }}>
                        Keluarkan Inventori
                      </span>
                    </DropdownItem>
                  </>
                )}
              </DropdownMenu>

            </UncontrolledDropdown>
          </div>

          {/* Footer Action: Standardized Lihat Detail */}
          <div
            className="p-1 border-top"
            style={{ backgroundColor: '#F9FAFB' }}
          >
            <button
              className="btn btn-link w-100 text-decoration-none d-flex align-items-center justify-content-center gap-2 py-2"
              style={{
                color: colors.primary[500],
                fontWeight: 600,
                fontSize: '0.9rem',
              }}
              onClick={() => {
                if (row?.parentGroupId) {
                  navigate(`${URL_INVENTORY}/${row?.id}`, {
                    state: row?.label,
                  })
                  setSearchInventory('')
                } else {
                  onShowHideModal('detail', true, 'general')
                  setSelectedStock({ ...row?.item, ...row })
                }
              }}
            >
              <span>Lihat Detail</span>
              <ChevronRight size={18} />
            </button>
          </div>
        </CardBody>
      </Card>
    )
  }

  const columns = [


    {
      name: <span>Tanggal</span>,
      sortable: true,
      sortField: 'createdAt',
      selector: (row) => formatDatePMBV2(row?.createdAt, row?.createdAt),
      cell: (row) => {
        return formatDatePMB(row?.createdAt, row?.createdAt)
      },
      minWidth: '150px',
      isFreeze: true,
      freezePosition: 'left',
    },
    {
      name: <span>Barang</span>,
      sortable: true,
      sortField: 'name',
      selector: (row) => row?.item?.nameItem || row?.label,
      cell: (row) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <span>{row?.item?.nameItem || row?.label}</span>
            </div>
          </>
        )
      },
      minWidth: '150px',
    },
    ...(searchInventory ? [{
      name: <span>Lokasi / Grup</span>,
      sortable: false,
      selector: (row) => row?.group?.label || '-',
      cell: (row) => {
        if (row?.group?.label && row?.group?.id) {
          return (
            <div 
              className="text-primary" 
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={(e) => {
                e.stopPropagation();
                localStorage.setItem('breadcrumbs', JSON.stringify([{ id: row.group.id, label: row.group.label }]));
                navigate(`${URL_INVENTORY}/${row.group.id}`, { 
                  state: {
                    label: row.group.label,
                    highlightedItemId: row.id,
                    action: 'searchInventory',
                    query: row?.item?.nameItem || row?.label
                  } 
                });
              }}
            >
              {row.group.label}
            </div>
          )
        }
        return <div>-</div>
      },
      minWidth: '150px',
    }] : []),
    {
      minWidth: '150px',
      name: <span>Lot ID</span>,
      sortable: true,
      sortField: 'lots',
      selector: (row) => {
        if (!row?.lots?.length) return '-'

        const userLots = row.lots.filter(
          (e) => e?.data?.creatorUserId === ownerData?.userId,
        )

        if (userLots.length === 0) return '-'

        const lastLot = userLots.reduce((latest, current) => {
          return new Date(current.data.createdAt) >
            new Date(latest.data.createdAt)
            ? current
            : latest
        })

        return lastLot.data.lotCode || '-'
      },
      cell: (row) => {
        if (!row?.lots?.length) return <div>-</div>

        const userLots = row.lots.filter(
          (e) => e?.data?.creatorUserId === ownerData?.userId,
        )

        if (userLots.length === 0) return <div>-</div>

        const lastLot = userLots.reduce((latest, current) => {
          return new Date(current.data.createdAt) >
            new Date(latest.data.createdAt)
            ? current
            : latest
        })

        return (
          <div className="d-flex align-items-center">
            {lastLot.data.lotCode || '-'}
          </div>
        )
      },
    },
    {
      name: <span>Kode Inventori</span>,
      sortable: true,
      sortField: 'ownerCode',
      selector: (row) => row?.ownerCode ?? '-',
      cell: (row) => {
        return (
          <div className="d-flex align-items-center">
            <span>{row?.ownerCode ?? '-'}</span>
          </div>
        )
      },
      minWidth: '150px',
    },
    {
      name: <span>Project</span>,
      sortable: true,
      sortField: 'projectLabel',
      selector: (row) => row?.projectLabel ?? '-',
      cell: (row) => {
        return (
          <div className="d-flex align-items-center">
            <span>{row?.projectLabel ?? '-'}</span>
          </div>
        )
      },
      minWidth: '150px',
    },
    {
      name: <span>Jumlah</span>,
      minWidth: '150px',
      sortable: true,
      right: true,
      sortField: 'amount',
      // Raw number so Excel export keeps it numeric; unit is its own column below
      selector: (row) => row?.amount || row?.totalInventory,
      cell: (row) => {
        return (
          <span>
            {intl.formatNumber(row?.amount || row?.totalInventory, {
              useGrouping: 'always',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}{' '}
            {row?.unit || row?.item?.unit}{' '}
          </span>
        )
      },
    },
    {
      // Export-only column; the table shows the unit inside Jumlah
      name: <span>Unit</span>,
      omit: true,
      selector: (row) => (row?.unit || row?.item?.unit || '-').toLowerCase(),
    },
    {
      name: <span>Bundle</span>,
      minWidth: '100px',
      sortable: true,
      right: true,
      sortField: 'bundle',
      selector: (row) => row?.bundle ?? 1,
      cell: (row) => {
        return <span>{row?.bundle ?? 1}</span>
      },
    },
    {
      name: <span>Gudang</span>,
      selector: (row) => row?.warehouse?.name || row?.warehouseName,
      cell: (row) => {
        return <span>{row?.warehouse?.name || row?.warehouseName}</span>
      },
      minWidth: '150px',
    },
    {
      name: <span>Keterangan</span>,
      center: true,
      selector: (row) => getActionWording(row?.source?.action, row),
      cell: (row) => {
        return (
          <div className="d-flex flex-column gap-2">
            <div
              className="bg-gray-100 badge rounded-pill px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              <span className="text-dark fw-medium text-capitalize">
                {getActionWording(row?.source?.action, row)}
              </span>
            </div>
            {row?.source?.escrowpaymentId ||
            row?.source?.warehousetransferId ? (
              <div
                className="bg-primary-50 badge rounded-pill px-2"
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  textAlign: 'center',
                  maxWidth: '100%',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  navigate(
                    `${row?.source?.escrowpaymentId ? URL_DETAIL_TRANSACTION : URL_TRANSFER_INVENTORY}/${row?.source?.escrowpaymentId ? row?.source?.escrowpaymentId : row?.source?.warehousetransferId}?type=${row?.source?.escrowpaymentId ? 'BUY' : 'in'}`,
                  )
                }
              >
                <span className="text-primary fw-medium text-capitalize">
                  {row?.source?.escrowpaymentId
                    ? row?.source?.poNumber
                    : `TF/ID/${row?.source?.warehousetransferId}`}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        )
      },
      minWidth: '150px',
    },
    {
      // Export-only column; the table shows this as a badge inside Keterangan
      name: <span>Referensi</span>,
      omit: true,
      selector: (row) =>
        row?.source?.escrowpaymentId
          ? row?.source?.poNumber || '-'
          : row?.source?.warehousetransferId
            ? `TF/ID/${row?.source?.warehousetransferId}`
            : '-',
    },
    {
      name: <span>Terakhir diperbarui</span>,
      sortable: true,
      sortField: 'updatedAt',
      selector: (row) =>
        row?.updatedAt ? formatDatePMBV2(row.updatedAt) : '-',
      cell: (row) => {
        return (
          <span>{row?.updatedAt ? formatDatePMB(row.updatedAt) : '-'}</span>
        )
      },
      minWidth: '150px',
    },
    {
      name: '',
      minWidth: '50px',
      isFreeze: true,
      freezePosition: 'right',
      cell: (row) => {
        const isPending = row?.pending
        return (
          <>
            <div className="d-flex gap-3 align-items-center">
              <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                <LihatDetail
                  className="button"
                  onClick={() => {
                    if (row?.parentGroupId) {
                      navigate(`${URL_INVENTORY}/${row?.id}`, {
                        state: row?.label,
                      })
                      setSearchInventory('')
                    } else {
                      onShowHideModal('detail', true, 'general')
                      setSelectedStock({ ...row?.item, ...row })
                    }
                  }}
                  id={row?.id}
                />
              </Can>
              {row?.parentGroupId ? (
                <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                  <Edit2
                    onClick={() => {
                      if (!isPending) {
                        setSelectedPacking(row)
                        onShowHideModal('renamePacking', true)
                      }
                    }}
                    size={20}
                    color={`${isPending ? '#D0D5DD' : '#475467'}`}
                    className="button"
                    disabled={isPending}
                    id={`tooltip-inventory-parent-edit-${row?.itemId}`}
                    style={{ cursor: isPending ? 'auto' : 'pointer' }}
                  />
                  {isPending && (
                    <PMBTooltip
                      placement="top"
                      target={`tooltip-inventory-parent-edit-${row?.itemId}`}
                      text={WORDING_TOOLTIP}
                    />
                  )}
                  <Trash2
                    onClick={() => {
                      if (!isPending) {
                        setSelectedPacking(row)
                        onShowHideModal('removePacking', true)
                      }
                    }}
                    size={20}
                    className={`button ${!isPending && 'text-danger'}`}
                    disabled={isPending}
                    style={{
                      color: isPending && '#D0D5DD',
                      cursor: isPending ? 'auto' : 'pointer',
                    }}
                    id={`tooltip-inventory-parent-remove-${row?.itemId}`}
                  />
                  {isPending && (
                    <PMBTooltip
                      placement="top"
                      target={`tooltip-inventory-parent-remove-${row?.itemId}`}
                      text={WORDING_TOOLTIP}
                    />
                  )}
                </Can>
              ) : (
                <>
                  <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                    <ResponsiveActionButton
                      iconName="menu"
                      label="Lihat QR"
                      onClick={() => {
                        onShowHideModal('qrCode', true, 'general')
                        setSelectedStock({ ...row?.item, ...row })
                      }}
                    />
                  </Can>

                  <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="div"
                        onClick={(e) => {
                          e.stopPropagation()
                          if (!isPending) fetchLabelItems(row)
                        }}
                        className="dropdown-toggle-wrapper"
                        disabled={isPending}
                      >
                        <div className="d-none d-sm-inline">
                          <MoreVertical
                            disabled={!isPending}
                            size={20}
                            color={`${isPending ? '#D0D5DD' : '#475467'}`}
                            className="button"
                            style={{ cursor: isPending ? 'auto' : 'pointer' }}
                            id={`${isPending && `tooltip-inventory-${row?.itemId}`}`}
                          />
                          {isPending && (
                            <PMBTooltip
                              placement="top"
                              target={`tooltip-inventory-${row?.itemId}`}
                              text={WORDING_TOOLTIP}
                            />
                          )}
                        </div>
                        <div className="d-inline d-sm-none">
                          <CustomButton outline disabled={isPending}>
                            <P size="small">Menu</P>
                          </CustomButton>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu container="body">
                        {menuStock
                          ?.filter(
                            (el) =>
                              !(el?.editType === 'split' && row?.deleted) &&
                              (el?.modal !== 'transfer' || canTransfer),
                          )
                          ?.map((el, i) => (
                            <DropdownItem
                              key={i}
                              className="mb-3 mt-3 pl-2 button d-flex align-items-center"
                              onClick={() => {
                                if (el?.modal === 'sell') {
                                  handleJualList([row])
                                  return
                                }
                                if (el?.modal === 'transfer') {
                                  handleTransferInventory([row])
                                  return
                                }
                                onShowHideModal(
                                  el?.modal,
                                  true,
                                  el?.editType,
                                  '',
                                  row,
                                )
                                onSelectStockMenu(row)
                                if (el?.modal === 'merge') {
                                  fetchGabungInventory(0, row)
                                }
                              }}
                            >
                              {el?.iconType === 'img' ? (
                                <img
                                  alt={el?.modal}
                                  src={el?.img}
                                  style={{
                                    width: 15,
                                    height: 15,
                                    marginRight: 10,
                                  }}
                                />
                              ) : el?.iconType === 'icon' &&
                                el?.icon === 'split' ? (
                                <Copy size={15} style={{ marginRight: 10 }} />
                              ) : el?.icon === 'eye' ? (
                                <Eye size={15} style={{ marginRight: 10 }} />
                              ) : el?.icon === 'sell' ? (
                                <JualIcon
                                  size={15}
                                  style={{ marginRight: 10 }}
                                />
                              ) : el?.icon === 'transfer' ? (
                                <Truck
                                  size={15}
                                  style={{ marginRight: 10 }}
                                />
                              ) : (
                                <Trash2
                                  size={15}
                                  style={{ marginRight: 10 }}
                                  color="#B42318"
                                />
                              )}
                              <span
                                style={{
                                  fontSize: 12,
                                  color:
                                    el?.icon === 'trash' ? '#B42318' : null,
                                }}
                              >
                                {el?.title}
                              </span>
                            </DropdownItem>
                          ))}

                        {row?.lots?.length > 0 && (
                          <DropdownItem
                            className="mb-3 mt-3 pl-2 button d-flex align-items-center"
                            onClick={() => {
                              onSelectStockMenu(row)
                              setSelectedDataRemove([row])
                              onShowHideModal('editLotId', true)
                            }}
                          >
                            <Edit2 size={15} style={{ marginRight: 10 }} />
                            <span
                              style={{
                                fontSize: 12,
                              }}
                            >
                              Edit Lot ID
                            </span>
                          </DropdownItem>
                        )}
                        <DropdownItem
                          className="mb-3 mt-3 pl-2 button d-flex align-items-center"
                          onClick={() => {
                            setDisplayAmount(row?.amount)
                            onSelectStockMenu(row)
                            setSelectedDataRemove([row])
                            onShowHideModal('confirmRemove', true)
                          }}
                        >
                          <Trash2
                            size={15}
                            style={{ marginRight: 10 }}
                            color="#B42318"
                          />
                          <span
                            style={{
                              fontSize: 12,
                              color: '#B42318',
                            }}
                          >
                            Hapus
                          </span>
                        </DropdownItem>

                        {isDetail ? (
                          <>
                            <DropdownItem
                              className="mb-3 mt-3 pl-2 button d-flex align-items-center"
                              onClick={() => handleOpenMoveInventoryModal([row])}
                            >
                              <CornerUpRight
                                size={15}
                                style={{ marginRight: 10 }}
                                color="#005370"
                              />
                              <span
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                Pindahkan ke Grup Lain
                              </span>
                            </DropdownItem>
                            <DropdownItem
                              className="mb-3 mt-3 pl-2 button d-flex align-items-center"
                              onClick={() => {
                                onSelectStockMenu(row)
                                setSelectedInventoryList([row])
                                onShowHideModal('removeItemPacking', true)
                              }}
                            >
                              <FolderMinus
                                size={15}
                                style={{ marginRight: 10 }}
                                color="#B42318"
                              />
                              <span
                                style={{
                                  fontSize: 12,
                                  color: '#B42318',
                                }}
                              >
                                Keluarkan Inventori
                              </span>
                            </DropdownItem>
                          </>
                        ) : (
                          <></>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </Can>
                </>
              )}
            </div>
          </>
        )
      },
    },
  ]

  const toggleMenuOption = (index) => {
    const updatedGroups = currentGroups.map((el, i) =>
      i === index ? { ...el, menuOption: !el.menuOption } : el,
    )
    setCurrentGroups(updatedGroups)
  }

  function updateBreadcrumbLocalStorage(data) {
    const STORAGE_KEY = 'breadcrumbs'

    try {
      const newData = [{ ...data }]
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newData))
    } catch (err) {
      console.error('Failed to update breadcrumbs manually:', err)
    }
  }

  const onClickAction = (type, data) => {
    if (type?.id === 1) {
      fetchGroupInventory(
        0,
        paginationGroup?.size,
        '',
        selectedSortGroup?.type,
        selectedSortGroup?.mode,
        '',
        data?.id,
      )

      if (data?.id && data?.label) {
        if (typeof onManageBreadCrumb === 'function') {
          onManageBreadCrumb({ id: data.id, label: data.label })
        } else {
          updateBreadcrumbLocalStorage({ id: data.id, label: data.label })
        }
      }
      navigate(`${URL_INVENTORY}/${data?.id}`, {
        state: data?.label,
      })
      setSearchGrupInventory('')
    } else if (type?.id === 2) {
      if (!data?.isPending) {
        setSelectedPacking(data)
        onShowHideModal('renamePacking', true)
      }
    } else {
      if (type?.id === 4) {
        setSelectedPacking(data)
        onShowHideModal('assignLotID', true)
      } else if (type?.id === 5) {
        handleJualGroup([data])
      } else if (type?.id === 6) {
        handleTransferGroup([data])
      } else {
        if (!data?.isPending) {
          setSelectedPacking(data)
          onShowHideModal('removePacking', true)
        }
      }
    }
  }

  const handleAddId = (data) => {
    setIdsGroup((prevIds) => [...prevIds, data])
  }

  const onLockValue = (targetItem) => {
    const updated = splitItems.map((item, idx) => {
      if (item === targetItem) {
        return {
          ...item,
          locked: !item.locked,
        }
      }
      return item
    })

    // Auto adjustment
    const totalInitial = parseFloat(selectedStock?.amount.replace(',', '.'))
    const lockedItems = updated.filter((item) => item.locked)
    const unlockedItems = updated.filter((item) => !item.locked)

    if (unlockedItems.length > 0) {
      const totalLockedAmount = lockedItems.reduce(
        (sum, item) =>
          sum + parseFloat(String(item.amount || '0').replace(',', '.')),
        0,
      )

      const remainingAmount = totalInitial - totalLockedAmount
      const equalDistribution = parseFloat(
        (remainingAmount / unlockedItems.length).toFixed(2),
      )

      let distributedTotal = 0
      const finalUpdated = updated.map((item, idx) => {
        if (item.locked) return item

        const unlockedIdx = unlockedItems.findIndex((uItem) => uItem === item)
        const isLastUnlocked = unlockedIdx === unlockedItems.length - 1

        let amountAdded
        if (isLastUnlocked) {
          amountAdded = parseFloat(
            (remainingAmount - distributedTotal).toFixed(2),
          )
        } else {
          amountAdded = equalDistribution
          distributedTotal += amountAdded
        }

        return {
          ...item,
          amount: amountAdded.toString().replace('.', ','),
        }
      })

      setSplitItems(finalUpdated)
    } else {
      setSplitItems(updated)
    }
  }

  useEffect(() => {
    if (isDetail && breadCrumbsData)
      setIdsGroup((prevIds) => [defaultWarehouse, ...breadCrumbsData])
  }, [isDetail, breadCrumbsData?.length])

  function normalizeDate(date) {
    const newDate = new Date(date)
    newDate.setHours(12, 0, 0, 0) // Hindari masalah timezone
    return newDate
  }

  return (
    <div className="w-100 px-3">
      <PMBProgressBarExportFile
        isDialogShow={isDownload}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => setIsDownload(false)}
      />
      <PremiumProgressModal
        isOpen={isCollectingGroup}
        current={collectingCurrent}
        total={collectingTotal}
        onCancel={() => {
          isCollectingRef.current = false
          setIsCollectingGroup(false)
        }}
        title="Menyiapkan Inventori"
      />
      {renderModal()}
      {showModal?.add ? (
        <Container className="custom-container pb-5">
          <div className="d-flex align-items-start gap-2 pt-3">
            <BreadCrumbs
              breadCrumbActive={'Tambah Inventori'}
              breadCrumbParent={'Inventori'}
              breadCrumbParentOnClick={() => onShowHideModal('add', false)}
            />
          </div>
          <Card className="w-100 border-0 shadow-sm">
            <AddStockModal
              isDetail={isDetail}
              locationBlocked={locationBlocked}
              isOpen={showModal?.add}
              onClose={() => {
                handleResetDataStock()
                onShowHideModal('add', false)
              }}
              items={itemsInventory}
              dataStock={dataStock}
              onShowItem={onShowHideModal}
              selectedUnit={selectedUnit}
              selectedStock={selectedStock}
              onChangeDataStock={onChangeDataStock}
              onChangeAmount={handleChangeInputSeparator}
              onChangeUnitValue={handleChangeInputUnitValueSeparator}
              loading={loading?.create}
              onCreateStock={(type, project) => {
                if (showModal?.merge) {
                  onMergeStock()
                } else {
                  onCreateStock(type, project)
                }
              }}
              defaultWarehouse={defaultWarehouse}
              onSelectItem={(item) => onSelectItem(item)}
              onSelectItemUnit={(item) => onSelectItemUnit(item)}
            />
          </Card>
        </Container>
      ) : (
        <>
          <div className="d-flex align-items-start gap-2 pt-3">
            {isDetail ? (
              <BreadCrumbs
                breadCrumbActive={
                  breadCrumbsData ?? [
                    { label: detail?.label ?? dataState, id: id },
                  ]
                }
                breadCrumbParent={'Inventori'}
                breadCrumbParentLink={URL_INVENTORY}
                onClickBreadCrumb={(data) => {
                  onManageBreadCrumb({
                    label: data?.label,
                    id: data?.id,
                  })
                  navigate(`${URL_INVENTORY}/${data?.id}`, {
                    state: data?.label,
                  })
                  setSearchGrupInventory('')
                }}
              />
            ) : (
              <BreadCrumbs breadCrumbActive={'Inventori'} />
            )}
          </div>
          {!isDetail ? (
            <Col className="mb-3">
              <p className="mb-2">Gudang</p>
              <div style={{ maxWidth: '340px' }} data-testid="inventory-warehouse-select">
                <Select
                  style={{ width: '100%' }}
                  options={warehouses?.newData}
                  onChange={(e) => {
                    localStorage.setItem(
                      'defaultWarehouseInventory',
                      JSON.stringify(e),
                    )
                    handleFilterWarehouse(e?.id)
                    setSelectedInventoryList([])
                  }}
                  placeholder="Pilih gudang"
                  value={warehouses?.newData?.find(
                    (e) => e?.id === defaultWarehouse?.id,
                  )}
                  components={{ Input: SelectInputWithTestId }}
                  data-testid="inventory-warehouse-select"
                  menuPortalTarget={
                    typeof window !== 'undefined' ? document.body : null
                  }
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
            </Col>
          ) : (
            <></>
          )}
          <Card className="mb-3 border-0 shadow-sm">
            <CardBody>
              <Row>
                <Col>
                  <h5 className="fw-semibold">Grup</h5>
                </Col>
                <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                  <Col className="d-flex justify-content-end">
                    {selectedGroupInventory?.length ? (
                      <div className="d-flex gap-2 align-items-center">
                        <span className="text-gray-500 me-2">
                          {selectedGroupInventory?.length + ' grup dipilih'}
                        </span>
                        {/* <CustomButton
                          className="btn-icon ml-1"
                          size="sm"
                          outline
                          id="pindahGudang"
                          color="primary"
                          onClick={() => {
                            onShowHideModal('pindahGudang', true)
                          }}
                        >
                          <CornerUpRight size={14} />
                        </CustomButton>
                        <UncontrolledTooltip
                          placement="bottom"
                          target="pindahGudang"
                        >
                          Pindah Gudang
                        </UncontrolledTooltip> */}
                        <>
                          <CustomButton
                            className="btn-icon ml-1"
                            size="sm"
                            outline
                            id="packing"
                            color="primary"
                            onClick={() => {
                              setIsSubGroup(true)
                              setSelectedFolder({})
                              onShowHideModal('addItemToGroup', true)
                              fetchGroupInventory(
                                0,
                                9999,
                                '',
                                selectedSortGroup?.type,
                                selectedSortGroup?.mode,
                                defaultWarehouse?.id,
                                breadCrumbsData?.[breadCrumbsData?.length - 1]
                                  ?.id,
                                'folder',
                              )
                              // handleAddId(defaultWarehouse)
                              setIdsGroup([
                                defaultWarehouse,
                                ...(breadCrumbsData || []),
                              ])
                            }}
                          >
                            <CornerUpRight size={14} />
                          </CustomButton>
                          <UncontrolledTooltip
                            placement="bottom"
                            target="packing"
                          >
                            Grupkan
                          </UncontrolledTooltip>
                        </>
                        {isDetail ? (
                          <CustomButton
                            className="btn-icon ml-1"
                            size="sm"
                            outline
                            id="removeItemPacking"
                            color="danger"
                            onClick={() => {
                              onShowHideModal('moveOutPacking', true)
                            }}
                          >
                            <FolderMinus size={14} />
                          </CustomButton>
                        ) : null}
                        <CustomButton
                          className="btn-icon ml-1"
                          size="sm"
                          outline
                          id="sellGroupBtn"
                          color="primary"
                          onClick={() => handleJualGroup()}
                        >
                          <JualIcon size={14} />
                        </CustomButton>
                        <UncontrolledTooltip
                          placement="bottom"
                          target="sellGroupBtn"
                        >
                          Jual
                        </UncontrolledTooltip>
                        {canTransfer && (
                          <>
                            <CustomButton
                              className="btn-icon ml-1"
                              size="sm"
                              outline
                              id="transferGroupBtn"
                              color="primary"
                              onClick={() =>
                                handleTransferGroup(selectedGroupInventory)
                              }
                              testId="inventory-group-bulk-transfer"
                            >
                              <Truck size={14} />
                            </CustomButton>
                            <UncontrolledTooltip
                              placement="bottom"
                              target="transferGroupBtn"
                            >
                              Transfer Grup
                            </UncontrolledTooltip>
                          </>
                        )}
                        <CustomButton
                          className="btn-icon ml-1"
                          size="sm"
                          outline
                          color="danger"
                          id="deleteBtn"
                          style={{ marginRight: 8 }}
                          onClick={() => onShowHideModal('removePacking', true)}
                        >
                          <Trash2 size={14} />
                        </CustomButton>
                        <UncontrolledTooltip
                          placement="bottom"
                          target="deleteBtn"
                        >
                          Hapus
                        </UncontrolledTooltip>{' '}
                      </div>
                    ) : null}
                    {/* {!isDetail ? ( */}
                    {isDetail ? (
                      <>
                        <CustomButton
                          className="btn-icon ml-1"
                          size="sm"
                          outline
                          id="sellEntireGroupBtn"
                          color="primary"
                          style={{ marginRight: 8 }}
                          onClick={() =>
                            handleJualGroup([
                              {
                                id: id,
                                label:
                                  detail?.label ||
                                  (typeof dataState === 'string'
                                    ? dataState
                                    : dataState?.label) ||
                                  breadCrumbsData?.[breadCrumbsData.length - 1]
                                    ?.label ||
                                  'Grup',
                              },
                            ])
                          }
                          disabled={isCollectingGroup}
                          testId="btn-sell-entire-group"
                        >
                          Jual Grup
                        </CustomButton>
                        {canTransfer && (
                          <CustomButton
                            className="btn-icon ml-1"
                            size="sm"
                            outline
                            id="transferEntireGroupBtn"
                            color="primary"
                            style={{ marginRight: 8 }}
                            onClick={() =>
                              handleTransferGroup([
                                {
                                  id: id,
                                  label:
                                    detail?.label ||
                                    (typeof dataState === 'string'
                                      ? dataState
                                      : dataState?.label) ||
                                    breadCrumbsData?.[breadCrumbsData.length - 1]
                                      ?.label ||
                                    'Grup',
                                  warehouse:
                                    detail?.warehouse || defaultWarehouse,
                                  warehouseId:
                                    detail?.warehouseId ||
                                    detail?.warehouse?.id ||
                                    defaultWarehouse?.id,
                                },
                              ])
                            }
                            disabled={isCollectingTransferGroup}
                            testId="btn-transfer-entire-group"
                          >
                            Transfer Grup
                          </CustomButton>
                        )}
                        <CustomButton
                          className="btn-icon ml-1"
                          size="sm"
                          outline
                          id="assignLotID"
                          color="primary"
                          style={{ marginRight: 8 }}
                          onClick={() => {
                            onShowHideModal('assignLotID', true)
                          }}
                        >
                          Atur Lot ID
                        </CustomButton>
                      </>
                    ) : null}
                    {breadCrumbsData?.length < 8 || !breadCrumbsData?.length ? (
                      <div>
                        <CustomButton
                          onClick={() => {
                            if (isDetail) {
                              setIsSubGroup(true)
                            }
                            onShowHideModal('packing', true)
                            setActionType('Buat')
                          }}
                          color="primary"
                          testId="inventory-create-group-button"
                        >
                          + Buat Grup
                        </CustomButton>
                      </div>
                    ) : null}

                    {/* ) : null} */}
                  </Col>
                </Can>
              </Row>
              <div className="d-flex gap-2 gap-md-3 mb-1 mb-md-2 flex-column flex-md-row mt-2">
                <div style={{ maxWidth: '346px' }} className="w-100 w-md-auto">
                  <PMBSearchInputGroup
                    label={'Cari'}
                    placeholder="Cari grup..."
                    onChange={(text) =>
                      handleSearchGroupChange(text.target.value)
                    }
                    value={searchGrupInventory}
                    maxWidth="100%"
                    placeholderColor="#6c757d"
                    testId="inventory-group-search-input"
                  />
                </div>

                {/* SELECT GRUP INVENTORI */}
                {/* {!isDetail ? (
                    <Col>
                      <p className="mb-2">Gudang</p>
                      <div style={{ maxWidth: '340px' }}>
                        <Select
                          style={{ width: '100%' }}
                          options={warehouses?.newData}
                          onChange={(e) => handleFilterGrup(e?.id)}
                          placeholder="Pilih gudang"
                          value={warehouses?.newData?.find(
                            (e) => e?.id === defaultWarehouse?.idGrup,
                          )}
                        />
                      </div>
                    </Col>
                  ) : (
                    <></>
                  )} */}
              </div>
              {loading?.group ? (
                <div className="group-card-container">
                  {[...Array(6)].map((_, i) => (
                    <CardSkeleton key={i} />
                  ))}
                </div>
              ) : currentGroups?.length < 1 ? (
                isDetail ? (
                  <span>Belum ada grup inventori di gudang ini.</span>
                ) : (
                  <span>
                    Belum ada grup inventori di gudang ini. Centang beberapa
                    inventori dan tekan tombol Grupkan untuk membuat grup
                    inventori.
                  </span>
                )
              ) : (
                <div>
                  <div className="group-card-container">
                    {currentGroups?.map((el, i) => {
                      return (
                        <div
                          key={i}
                          className="group-card"
                          onClick={() => onClickAction({ id: 1 }, el)}
                          data-testid={`inventory-group-card-${el?.id}`}
                        >
                          <div>
                            <div className="d-flex">
                              <div style={{ flex: 1 }}>
                                <P size="regular" bold>
                                  {el?.label}
                                </P>
                              </div>
                              <Dropdown
                                toggle={() => {
                                  if (el?.menuOption) {
                                    toggleMenuOption(i)
                                  }
                                }}
                                isOpen={el?.menuOption}
                              >
                                <DropdownToggle
                                  data-toggle="dropdown"
                                  tag="span"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Input
                                    id="isKomoditas"
                                    type="checkbox"
                                    name="isKomoditas"
                                    style={{ cursor: 'pointer' }}
                                    checked={selectedGroupInventory.some(
                                      (item) => item?.id === el?.id,
                                    )}
                                    onChange={(e) => {
                                      e.stopPropagation()
                                      onSelectGroup(el)
                                    }}
                                    size={20}
                                    data-testid={`inventory-group-checkbox-${el?.id}`}
                                  />
                                  <MoreVertical
                                    color="#667085"
                                    size={20}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      toggleMenuOption(i)
                                      setSelectedGroup(el)
                                    }}
                                    style={{ marginLeft: 10, marginBottom: 3 }}
                                  />
                                </DropdownToggle>
                                <DropdownMenu style={{ paddingLeft: 10 }}>
                                  {groupActionMenu
                                    ?.filter(
                                      (item) => item?.id !== 6 || canTransfer,
                                    )
                                    ?.map((item, i) => {
                                    return (
                                      <div
                                        key={i}
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          onClickAction(item, selectedGroup)
                                        }}
                                        style={{
                                          flexDirection: 'row',
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginTop: i > 0 ? 10 : 0,
                                          cursor: 'pointer',
                                        }}
                                      >
                                        {item?.icon}
                                        <Text
                                          size="regular"
                                          style={{ marginLeft: 10 }}
                                        >
                                          {item?.label}
                                        </Text>
                                      </div>
                                    )
                                  })}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div>
                              <P size="small" color={'#475467'}>
                                {el?.totalInventory || 10} Inventori •{' '}
                                {formatNumber(el?.totalAmount || 0)}kg
                              </P>
                            </div>
                          </div>
                          <div>
                            <P size="small" color={'#475467'}>
                              {el?.updatedAt
                                ? formatDatePMBV2(el.updatedAt)
                                : '-'}
                            </P>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  <div>
                    <PMBPagination
                      rowCount={paginationGroup?.totalItems}
                      currentPage={paginationGroup?.currentPage}
                      rowsPerPage={paginationGroup?.size}
                      customRowsPerPageOptions={[12, 16, 20]}
                      setCurrentPage={(e, size) => {
                        fetchGroupInventory(
                          e,
                          size || paginationGroup?.size,
                          '',
                          selectedSortGroup?.type,
                          selectedSortGroup?.mode,
                          defaultWarehouse?.id,
                          '',
                        )
                      }}
                      setRowsPerPage={(e) => {
                        setPaginationGroup((prevState) => ({
                          ...prevState,
                          size: e,
                          page: 0,
                        }))
                        fetchGroupInventory(
                          0,
                          e,
                          '',
                          selectedSortGroup?.type,
                          selectedSortGroup?.mode,
                          defaultWarehouse?.id,
                          '',
                        )
                      }}
                    />
                  </div>
                </div>
              )}
            </CardBody>
          </Card>

          <Card className="mb-3 border-0 shadow-sm">
            <CardBody>
              {/* Select All Banner Moved to subHeaderComponent */}
              <DataTable
                columns={columns}
                data={inventoryList}
                progressPending={loading?.getInventory}
                progressComponent={<TableSkeleton />}
                selectableRows={true}
                onSelectedRowsChange={handleRowSelected}
                selectableRowDisabled={(row) => row?.pending === true}
                clearSelectedRows={clearRows}
                selectableRowSelected={checkRowSelected}
                conditionalRowStyles={[
                  {
                    when: (row) => row.pending === true,
                    style: {
                      backgroundColor: '#f6f6f6',
                      color: '#b0b0b0',
                      opacity: 0.7,
                      cursor: 'not-allowed',
                    },
                  },
                  ...(dataState?.highlightedItemId ? [{
                    when: (row) => String(row.id) === String(dataState.highlightedItemId),
                    classNames: ['row-new-highlight'],
                  }] : [])
                ]}
                renderMobileCard={renderMobileCard}

                sortIcon={<ChevronDown />}
                sortServer
                onSort={handleSort}
                defaultSortFieldId={1}
                defaultSortAsc={false}
                noDataComponent={
                  <p className="my-3 fw-semibold">
                    Belum ada inventori yang ditambahkan.
                  </p>
                }
                pagination
                paginationServer
                paginationComponent={(props) => (
                  <PMBPagination
                    rowCount={totalItems}
                    currentPage={currentPage}
                    rowsPerPage={size ?? 10}
                    customRowsPerPageOptions={[10, 20, 30, 50, 100, 200]}
                    setCurrentPage={(e) => {
                      setCurrentPage(e)
                    }}
                    setRowsPerPage={(e) => {
                      setSize(e)
                    }}
                    props={props}
                    testId="inventory-pagination"
                  />
                )}
                subHeader={true}
                subHeaderComponent={
                  <div className="w-100">
                    <Row className="mb-2 align-items-center inventory-toolbar-row">
                      <Col xs={12} md="auto" className="mb-2 mb-md-0">
                        <h5 className="fw-semibold mb-0">Inventori</h5>
                        {/* Mobile-only Select All Toggle */}
                        <div className="d-flex d-md-none align-items-center mt-2 mb-1 ps-1 py-1">
                          <div
                            onClick={toggleAll}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                          >
                            {getCheckboxIcon()}
                            <span className="ms-2 fw-medium text-dark" style={{ fontSize: '0.9rem' }}>
                              Pilih Semua
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md className="inventory-toolbar__actions-col">
                        <Can I={MANAGE} this={BUSINESS_INVENTORY}>
                          <div className="inventory-toolbar">
                            {selectedInventoryList?.length ? (
                              <div className="inventory-toolbar__bulk d-flex gap-2 align-items-center justify-content-end flex-wrap flex-md-nowrap">
                                <span className="text-gray-500 me-2"></span>
                                {isDetail ? (
                                  <>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      outline
                                      id="packingDetail"
                                      color="primary"
                                      onClick={() =>
                                        handleOpenMoveInventoryModal(
                                          selectedInventoryList,
                                        )
                                      }
                                      testId="inventory-detail-bulk-group"
                                    >
                                      <CornerUpRight size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="packingDetail"
                                    >
                                      Pindahkan Grup
                                    </UncontrolledTooltip>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      // size="sm"
                                      outline
                                      id="removeItemPacking"
                                      color="danger"
                                      onClick={() => {
                                        onShowHideModal(
                                          'removeItemPacking',
                                          true,
                                        )
                                      }}
                                    >
                                      <FolderMinus size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="removeItemPacking"
                                    >
                                      Keluarkan Inventori
                                    </UncontrolledTooltip>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      outline
                                      id="sellBtnDetail"
                                      color="primary"
                                      onClick={() =>
                                        handleJualList(selectedInventoryList)
                                      }
                                      testId="inventory-detail-bulk-sell"
                                    >
                                      <JualIcon size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="sellBtnDetail"
                                    >
                                      Jual
                                    </UncontrolledTooltip>
                                    {canTransfer && (
                                      <>
                                        <CustomButton
                                          className="btn-icon ml-1"
                                          outline
                                          id="transferBtnDetail"
                                          color="primary"
                                          onClick={() =>
                                            handleTransferInventory(
                                              selectedInventoryList,
                                            )
                                          }
                                          testId="inventory-detail-bulk-transfer"
                                        >
                                          <Truck size={14} />
                                        </CustomButton>
                                        <UncontrolledTooltip
                                          placement="bottom"
                                          target="transferBtnDetail"
                                        >
                                          Transfer Inventori
                                        </UncontrolledTooltip>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      // size="sm"
                                      outline
                                      id="printBulk"
                                      color="primary"
                                      onClick={async () => {
                                        if (selectedInventoryList.length > 0) {
                                          setModalInventoryList(selectedInventoryList)
                                          setModalInventoryTotalItems(selectedInventoryList.length)
                                          onShowHideModal('bulkQrCode', true)
                                        } else {
                                          await fetchModalInventory(0)
                                          onShowHideModal('bulkQrCode', true)
                                        }
                                      }}
                                      testId="inventory-bulk-print-qr"
                                    >
                                      <Printer size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="printBulk"
                                    >
                                      Print QR (Bulk)
                                    </UncontrolledTooltip>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      // size="sm"
                                      outline
                                      id="assignLotID"
                                      color="primary"
                                      onClick={() => {
                                        onShowHideModal('assignLotID', true)
                                      }}
                                      testId="inventory-bulk-assign-lot"
                                    >
                                      <FilePlus size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="assignLotID"
                                    >
                                      Atur Lot ID
                                    </UncontrolledTooltip>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      // size="sm"
                                      outline
                                      id="packing"
                                      color="primary"
                                      onClick={() =>
                                        handleOpenMoveInventoryModal(
                                          selectedInventoryList,
                                        )
                                      }
                                      testId="inventory-bulk-group"
                                    >
                                      <CornerUpRight size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="packing"
                                    >
                                      Grupkan
                                    </UncontrolledTooltip>

                                    <CustomButton
                                      className="btn-icon ml-1"
                                      outline
                                      id="sellBtn"
                                      color="primary"
                                      onClick={() =>
                                        handleJualList(selectedInventoryList)
                                      }
                                      testId="inventory-bulk-sell"
                                    >
                                      <JualIcon size={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="sellBtn"
                                    >
                                      Jual
                                    </UncontrolledTooltip>
                                    {canTransfer && (
                                      <>
                                        <CustomButton
                                          className="btn-icon ml-1"
                                          outline
                                          id="transferBtn"
                                          color="primary"
                                          onClick={() =>
                                            handleTransferInventory(
                                              selectedInventoryList,
                                            )
                                          }
                                          testId="inventory-bulk-transfer"
                                        >
                                          <Truck size={14} />
                                        </CustomButton>
                                        <UncontrolledTooltip
                                          placement="bottom"
                                          target="transferBtn"
                                        >
                                          Transfer Inventori
                                        </UncontrolledTooltip>
                                      </>
                                    )}
                                  </>
                                )}
                                {selectedInventoryList?.length > 1 ? (
                                  <>
                                    <CustomButton
                                      className="btn-icon ml-1"
                                      // size="sm"
                                      outline
                                      color="primary"
                                      id="mergeBtn"
                                      onClick={() => {
                                        const firstUnit =
                                          selectedInventoryList?.[0]?.unit
                                        const allSameUnit =
                                          selectedInventoryList?.every(
                                            (item) => item?.unit === firstUnit,
                                          )

                                        let unitToSet = 'Kg'

                                        if (allSameUnit && firstUnit) {
                                          unitToSet = firstUnit
                                        } else {
                                          unitToSet = 'Kg'
                                        }

                                        onChangeDataStock('unit', unitToSet)

                                        const matchedUnit = itemUnitList?.find(
                                          (u) =>
                                            u?.title?.toLowerCase() ===
                                            unitToSet?.toLowerCase(),
                                        )
                                        if (matchedUnit) {
                                          setSelectedUnit({
                                            value:
                                              matchedUnit.title?.toLowerCase(),
                                            label: matchedUnit.title,
                                            ...matchedUnit,
                                          })
                                        }

                                        onShowHideModal('mergeInventory', true)
                                        fetchItemsInventory()
                                        setDisplayAmount(
                                          String(
                                            newFormatThousandSeparator(
                                              selectedInventoryList?.reduce(
                                                (total, item) =>
                                                  total + (item?.amount || 0),
                                                0,
                                              ),
                                            ),
                                          ),
                                        )
                                      }}
                                      testId="inventory-bulk-merge"
                                    >
                                      <MergeIcon width={14} height={14} />
                                    </CustomButton>
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="mergeBtn"
                                    >
                                      Gabungkan
                                    </UncontrolledTooltip>
                                  </>
                                ) : null}

                                <>
                                  <CustomButton
                                    className="btn-icon ml-1"
                                    // size="sm"
                                    outline
                                    color="danger"
                                    id="deleteBtn"
                                    onClick={() => {
                                      // onShowHideModal(
                                      //   'confirmRemoveMultiple',
                                      //   true,
                                      // )
                                      setDisplayAmount(
                                        selectedDataRemove?.[0]?.amount,
                                      )
                                      onShowHideModal('confirmRemove', true)
                                    }}
                                    testId="inventory-bulk-delete"
                                  >
                                    <Trash2 size={14} />
                                  </CustomButton>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target="deleteBtn"
                                  >
                                    Hapus
                                  </UncontrolledTooltip>{' '}
                                </>
                                <span className="text-gray-300 d-none d-md-inline">|</span>
                              </div>
                            ) : null}
                            <div className="inventory-toolbar__controls">
                              <div className="inventory-toolbar__add-btn-wrapper">
                                <CustomButton
                                  onClick={() => {
                                    onShowHideModal('add', true)
                                    fetchItemsInventory()
                                  }}
                                  color="primary"
                                  className="w-100 w-md-auto"
                                >
                                  <Plus size={16} color="#fff" /> Tambah
                                  Inventori
                                </CustomButton>
                              </div>
                              <div className="inventory-toolbar__utility-row">
                                {activeFilterCount > 0 && (
                                  <div className="flex-shrink-0">
                                    <CustomButton
                                      onClick={handleResetFilter}
                                      color="danger"
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        padding: 0,
                                        minWidth: '40px',
                                      }}
                                    >
                                      <X size={16} />
                                    </CustomButton>
                                  </div>
                                )}
                                <div className="inventory-toolbar__btn-slot">
                                  <CustomButton
                                    onClick={() =>
                                      setIsShowFilter((prevState) => !prevState)
                                    }
                                    color="primary"
                                    outline
                                    className="w-100 position-relative"
                                  >
                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                      <Filter size={15} />
                                      <P>Filter</P>
                                      {activeFilterCount > 0 && (
                                        <Badge
                                          color="danger"
                                          pill
                                          style={{
                                            position: 'absolute',
                                            top: '-5px',
                                            right: '-5px',
                                            fontSize: '10px',
                                          }}
                                        >
                                          {activeFilterCount}
                                        </Badge>
                                      )}
                                      {isShowFilter ? (
                                        <ChevronUp size={16} className="ml-2" />
                                      ) : (
                                        <ChevronDown
                                          size={16}
                                          className="ml-2"
                                        />
                                      )}
                                    </div>
                                  </CustomButton>
                                </div>
                                  <div className="inventory-toolbar__btn-slot">
                                    <CustomButton
                                      onClick={async () => {
                                        if (selectedInventoryList.length > 0) {
                                          setModalInventoryList(selectedInventoryList)
                                          setModalInventoryTotalItems(selectedInventoryList.length)
                                          onShowHideModal('bulkQrCode', true)
                                        } else {
                                          await fetchModalInventory(0)
                                          onShowHideModal('bulkQrCode', true)
                                        }
                                      }}
                                      color="primary"
                                      outline
                                      className="d-flex align-items-center gap-2 w-100 justify-content-center"
                                      style={{ height: '40px' }}
                                    >
                                      <Printer size={15} />
                                      <span className="fw-bold text-nowrap" style={{ fontSize: '0.85rem' }}><P>Print QR</P></span>
                                    </CustomButton>
                                  </div>
                                  <div className="inventory-toolbar__btn-slot">
                                    <CustomButton
                                      onClick={handleExportInventory}
                                      color="primary"
                                      outline
                                      className="d-flex align-items-center gap-2 w-100 justify-content-center"
                                    >
                                      <Download size={15} />
                                      <P>Download</P>
                                    </CustomButton>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </Can>
                      </Col>
                    </Row>

                    <Collapse isOpen={isShowFilter}>
                      <div
                        className="border rounded p-3 bg-light mb-3 filter-collapse"
                        style={{
                          width: '100%',
                          transition: 'all 0.3s ease-in-out',
                          opacity: isShowFilter ? 1 : 0,
                          transform: isShowFilter
                            ? 'translateY(0)'
                            : 'translateY(-10px)',
                        }}
                      >
                        <Row className="g-2">
                          <Col xs={12} md={4} lg={3}>
                            <PMBSearchInputGroup
                              label={'Cari'}
                              placeholder="Cari inventori..."
                              onChange={(text) =>
                                handleSearchChange(text.target.value)
                              }
                              value={searchInventory}
                              maxWidth="100%"
                              placeholderColor="#6c757d"
                              loading={loading?.getInventory}
                              testId="inventory-search-input"
                            />
                          </Col>
                          <Col xs={12} md="auto" lg="auto">
                            <PMBDateRangePicker
                              style={{ width: '100%', maxWidth: '100%' }}
                              value={
                                dateFilter.from && dateFilter.to
                                  ? [
                                      moment(dateFilter.from).format(
                                        'YYYY-MM-DD',
                                      ),
                                      moment(dateFilter.to).format(
                                        'YYYY-MM-DD',
                                      ),
                                    ]
                                  : []
                              }
                              onChange={(dates) => {
                                if (dates?.length === 2) {
                                  handleDateChange(dates)
                                }
                              }}
                              format="yyyy-mm-dd"
                              label={'Tanggal Dibuat'}
                              onClear={() => {
                                setDateFilter({
                                  from: null,
                                  to: null,
                                })
                                fetchInventory(
                                  0,
                                  size,
                                  searchInventory,
                                  selectedSort?.type,
                                  selectedSort?.mode,
                                  defaultWarehouse?.id,
                                  id,
                                  null,
                                  null,
                                  statusFilter?.value,
                                  projectFilterRef.current?.value || null,
                                )
                              }}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={3}>
                            <p className="mb-1">Keterangan</p>
                            <PMBSelect
                              className="w-100"
                              placeholder="Pilih filter keterangan"
                              options={statusOptions}
                              value={statusFilter}
                              onChange={handleStatusChange}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={3}>
                            <p className="mb-1">Project</p>
                            <div style={{ maxWidth: '100%' }}>
                              <PMBProjectSelections
                                value={projectFilter}
                                onChange={handleProjectChange}
                                placeholder="Pilih proyek"
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Collapse>

                    {/* Select All Banner */}
                    {selectedInventoryList?.length > 0 && (
                      <div
                        className="inventory-toolbar__selection-banner d-flex justify-content-center align-items-center p-2 mb-2 rounded"
                        style={{
                          backgroundColor: '#e6f7ff',
                          border: '1px solid #91d5ff',
                          color: '#0050b3',
                        }}
                      >
                        {isAllSelected ? (
                          <span>
                            Semua{' '}
                            <strong>{selectedInventoryList.length}</strong>{' '}
                            inventori terpilih
                            {totalItems > selectedInventoryList.length && (
                              <span>
                                {' '}
                                ({totalItems -
                                  selectedInventoryList.length}{' '}
                                item tidak dapat dipilih)
                              </span>
                            )}
                            .{' '}
                            <span
                              role="button"
                              className="fw-bold text-decoration-underline"
                              style={{ cursor: 'pointer' }}
                              onClick={handleClearSelection}
                            >
                              Batalkan pilihan
                            </span>
                          </span>
                        ) : (
                          <span>
                            <strong>{selectedInventoryList?.length}</strong>{' '}
                            inventori terpilih.
                            {otherPageSelectedCount > 0 && (
                              <span>
                                {' '}
                                ({otherPageSelectedCount} di halaman lain)
                              </span>
                            )}
                            {/* Always show Global Select option if total > page size */}{' '}
                            {totalItems > inventoryList?.length && (
                              <>
                                {' '}
                                {selectedInventoryList?.length ===
                                  inventoryList?.length &&
                                  '(Semua di halaman ini). '}
                                {isSelectingAll ? (
                                  <span className="fw-bold ms-1">
                                    Memuat...
                                  </span>
                                ) : (
                                  <span
                                    role="button"
                                    className="fw-bold text-decoration-underline"
                                    style={{ cursor: 'pointer' }}
                                    onClick={handleSelectAll}
                                  >
                                    Pilih semua {totalItems} inventori yang
                                    cocok dengan filter
                                  </span>
                                )}
                              </>
                            )}
                            {' '}
                            <span
                              role="button"
                              className="fw-bold text-decoration-underline"
                              style={{ cursor: 'pointer', color: '#cf1322' }}
                              onClick={handleClearSelection}
                            >
                              Batalkan semua pilihan
                            </span>
                          </span>
                        )}
                      </div>
                    )}

                    {toast?.show ? (
                      <Card
                        className="small-padding mb-4"
                        style={{
                          backgroundColor: '#ECFDF3',
                          borderColor: '#027948',
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <CheckCircle
                              size={16}
                              className="small-margin-right"
                              color="#006386"
                            />
                            <CardText style={{ fontSize: 14 }}>
                              {toast?.title}
                            </CardText>
                          </div>
                          <X
                            className="button"
                            size={16}
                            color="#667085"
                            onClick={() => setToast({ show: false })}
                          />
                        </div>
                      </Card>
                    ) : null}
                  </div>
                }
              />
              <div>
                <InventorySummaryCard
                  warehouseId={defaultWarehouse?.id ?? null}
                  groupId={parentGroupId}
                  isDetail={isDetail}
                  isRefresh={isFetchSummary}
                  setFetchSummary={setFetchSummary}
                  from={dateFilter?.from}
                  to={dateFilter?.to}
                  method={statusFilter?.value}
                  search={searchInventory}
                  sortBy={selectedSort?.type}
                  sortDir={selectedSort?.mode}
                  projectId={projectFilterRef.current?.value}
                  forpage={'inventory'}
                  totalItemsInventory={totalItems}
                />
              </div>
            </CardBody>
          </Card>
        </>
      )}
    </div>
  )

  function renderModal() {
    const totalInitial = selectedStock?.amount ?? 0
    const totalAmountAfter = splitItems.reduce((sum, item) => {
      const amountStr = String(item.amount || '0') // pastikan string
      const numericValue = parseFloat(amountStr.replace(',', '.'))
      return sum + (isNaN(numericValue) ? 0 : numericValue)
    }, 0)

    return (
      <>
        <ModalEditLotId
          isOpen={showModal?.editLotId}
          onClose={() => onShowHideModal('editLotId', false)}
          data={selectedStock}
          setIsFetch={setIsFetch}
        />
        <Modal isOpen={showModal?.confirmSplit} centered>
          <div className="p-3">
            <P size="large">Konfirmasi Pembagian Stok</P>
            <P className="mt-4">
              Jumlah total hasil pembagian berbeda dari jumlah stok awal. Apakah
              Anda yakin ingin melanjutkan proses split?
            </P>
            <div className="mb-3 mt-3">
              <div className="d-flex gap-2">
                <P className="text-muted">Jumlah Sebelumnya</P>
                <P className="fw-bold">
                  {totalInitial} {capitalizeEveryWord(selectedStock?.unit)}
                </P>
              </div>
              <div className="d-flex gap-2">
                <P className="text-muted">Jumlah Setelah Split</P>
                <P className="fw-bold">
                  {totalAmountAfter?.toFixed(2)}{' '}
                  {capitalizeEveryWord(selectedStock?.unit)}
                </P>
              </div>
            </div>
            <div className="mt-4 d-flex" style={{ flex: 1, gap: 6 }}>
              <div style={{ flex: 1 }}>
                <CustomButton
                  color="primary"
                  style={{ width: '100%' }}
                  onClick={() => {
                    setShowModal((prev) => ({ ...prev, confirmSplit: false }))
                    onSplitStock()
                  }}
                >
                  Lanjut
                </CustomButton>
              </div>
              <div style={{ flex: 1 }}>
                <CustomButton
                  outline
                  color="primary"
                  style={{ width: '100%' }}
                  onClick={() =>
                    setShowModal((prev) => ({ ...prev, confirmSplit: false }))
                  }
                >
                  Batal
                </CustomButton>
              </div>
            </div>
          </div>
        </Modal>
        <ModalPindahGudang
          isOpen={showModal?.pindahGudang}
          onClose={() => onShowHideModal('pindahGudang', false)}
        />
        <ModalConfirmTransfer
          isOpen={showModalTransfer}
          onClose={() => setShowModalTransfer(false)}
          onConfirm={handleConfirmTransfer}
          transferData={transferModalData}
          loading={isCollectingTransferGroup}
        />
        <ModalPacking
          isOpen={showModal?.packing}
          onClose={(type, createdGroup) => {
            onShowHideModal('packing', false)
            if (type === 'success') {
              const hasSelectedItems =
                (isSubGroup && selectedGroupInventory?.length > 0) ||
                (showModal?.detail && selectedStock?.id) ||
                selectedInventoryList?.length > 0

              if (!showModal?.addItemToGroup || hasSelectedItems) {
                onShowHideModal('detail', false)
                onShowHideModal('addItemToGroup', false)
                setSelectedFolder({})
                setSelectedInventoryList([])
                setSelectedGroupInventory([])
                toggleClearRows()
                setIsFetch('all')
                if (isDetail && id) {
                  dispatch(getPackingDetail({ page: 0, id }))
                }
                fetchGroupInventory(
                  0,
                  paginationGroup?.size || 12,
                  searchGrupInventory,
                  selectedSortGroup?.type || 'updatedAt',
                  selectedSortGroup?.mode || 'desc',
                  defaultWarehouse?.id,
                  id,
                )
              } else {
                fetchGroupInventory(
                  0,
                  9999,
                  '',
                  selectedSortGroup?.type || 'updatedAt',
                  selectedSortGroup?.mode || 'desc',
                  defaultWarehouse?.id,
                  selectedFolder?.id || id || parentGroupId || '',
                  'folder',
                )
                fetchGroupInventory(
                  0,
                  paginationGroup?.size || 12,
                  searchGrupInventory,
                  selectedSortGroup?.type || 'updatedAt',
                  selectedSortGroup?.mode || 'desc',
                  defaultWarehouse?.id,
                  id,
                )
                if (createdGroup?.id) {
                  setSelectedFolder(createdGroup)
                }
              }
            }
          }}
          data={
            isSubGroup && selectedGroupInventory?.length
              ? selectedGroupInventory
              : showModal?.detail
                ? [selectedStock]
                : selectedInventoryList
          }
          setIsFetch={setIsFetch}
          setSelectedInventoryList={
            !showModal?.addItemToGroup && isSubGroup
              ? setSelectedGroupInventory
              : setSelectedInventoryList
          }
          toggleClearRows={isSubGroup ? toggleClearRowsGroup : toggleClearRows}
          isSubGroup={isSubGroup}
          packing={showModal?.packing}
          setSelectedStock={(data) => {
            setSelectedStock((prevState) => ({ ...prevState, ...data }))
          }}
          actionType={actionType}
          warehouseId={defaultWarehouse?.id}
          selectedFolder={selectedFolder?.id ? selectedFolder : { id: id }}
          isAddItemToGroup={showModal?.addItemToGroup}
        />
        <ModalRenamePacking
          isOpen={showModal?.renamePacking}
          onClose={() => onShowHideModal('renamePacking', false)}
          data={selectedPacking}
          setIsFetch={setIsFetch}
          isDetail={isDetail}
        />
        <ModalRemovePacking
          isOpen={showModal?.removePacking}
          onClose={() => {
            onShowHideModal('removePacking', false)
          }}
          data={
            selectedGroupInventory?.length > 0
              ? selectedGroupInventory
              : selectedPacking
          }
          isDetail={isDetail}
          setIsFetch={setIsFetch}
          setSelectedGroupInventory={setSelectedGroupInventory}
          toggleClearRowsGroup={toggleClearRowsGroup}
        />
        <ModalRemoveItemPacking
          isOpen={showModal?.removeItemPacking}
          onClose={() => {
            onShowHideModal('removeItemPacking', false)
            onShowHideModal('detail', false)
          }}
          data={selectedInventoryList}
          setIsFetch={setIsFetch}
          setSelectedInventoryList={setSelectedInventoryList}
        />
        <ModalRemoveItemPacking
          isOpen={showModal?.moveOutPacking}
          onClose={() => onShowHideModal('moveOutPacking', false)}
          data={selectedGroupInventory}
          setIsFetch={setIsFetch}
          type={'group'}
          setSelectedInventoryList={setSelectedInventoryList}
        />
        <ActionModal
          isOpen={showModal?.menuOption}
          onClose={() => onShowHideModal('menuOption', false)}
          onSelectMenu={(item) =>
            onShowHideModal(item?.modal, true, item?.editType)
          }
        />
        <AddStockGroupModal
          inventoryList={
            showModal?.detail
              ? [selectedStock]
              : isSubGroup
                ? selectedGroupInventory
                : selectedInventoryList
          }
          isOpen={showModal?.addItemToGroup}
          onShowCreateGroup={() => {
            onShowHideModal('packing', true)
          }}
          groupList={currentFolder}
          folderList={idsGroup}
          selectedFolder={selectedFolder}
          isDetail={isDetail}
          currentGroupId={id}
          onPressSelectFolder={(data) => {
            setSelectedFolder((prev) => {
              if (prev?.id === data.id) {
                return idsGroup?.length > 1 ? idsGroup[idsGroup.length - 1] : {}
              }
              return data
            })
          }}
          onPressBack={() => {
            setIdsGroup((prevIds) => {
              const updatedIds = prevIds.slice(0, -1)
              const parent = updatedIds[updatedIds?.length - 1]
              const isRoot = updatedIds.length <= 1
              fetchGroupInventory(
                0,
                9999,
                '',
                selectedSortGroup?.type || 'updatedAt',
                selectedSortGroup?.mode,
                isRoot ? defaultWarehouse?.id : '',
                isRoot ? '' : parent?.id,
                'folder',
              )
              setSelectedFolder(isRoot ? {} : parent)
              return updatedIds
            })
          }}
          onPressCancel={() => {
            onShowHideModal('addItemToGroup', false)
            setSelectedFolder({})
            setIdsGroup([])
          }}
          onPressOpenFolder={(data) => {
            setSelectedFolder(data)
            fetchGroupInventory(
              0,
              9999,
              '',
              selectedSortGroup?.type || 'updatedAt',
              selectedSortGroup?.mode,
              '',
              data?.id,
              'folder',
            )
            handleAddId(data)
          }}
          onToSpecificGroup={(data, index) => {
            setSelectedFolder(index === 0 ? {} : data)
            setIdsGroup((prevIds) => {
              const updatedIds = prevIds.slice(0, index + 1)
              if (index === 0) {
                fetchGroupInventory(
                  0,
                  9999,
                  '',
                  selectedSortGroup?.type || 'updatedAt',
                  selectedSortGroup?.mode,
                  data?.id,
                  '',
                  'folder',
                )
              } else {
                fetchGroupInventory(
                  0,
                  9999,
                  '',
                  selectedSortGroup?.type || 'updatedAt',
                  selectedSortGroup?.mode,
                  '',
                  data?.id,
                  'folder',
                )
              }
              return updatedIds
            })
          }}
          onGroupInventory={() => {
            if (isSubGroup) {
              onCreateGroupForGroup()
            } else {
              onAddInventoryToGroup(
                showModal?.detail ? [selectedStock] : selectedInventoryList,
                selectedFolder?.id,
              )
            }
            onShowHideModal('addItemToGroup', false)
            setSelectedFolder({})
            setIdsGroup([])
          }}
        />
        <SidebarDetails
          open={showModal?.qrCode}
          title="Detail Informasi"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => onShowHideModal('qrCode', false)}
        >
          <IDStockModal
            isOpen={showModal?.qrCode}
            onClose={() => onShowHideModal('qrCode', false)}
            selectedStock={selectedStock}
          />
        </SidebarDetails>

        <SidebarDetails
          open={showModal?.edit}
          title="Ubah Data"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => onShowHideModal('edit', false)}
          style={{ border: 'none' }}
        >
          <EditStockModal
            isOpen={showModal?.edit}
            onClose={() => onShowHideModal('edit', false)}
            selectedEditAction={selectedEditAction}
            selectedStock={selectedStock}
            onChangeSelectedDataStock={onChangeSelectedDataStock}
            onShowItem={onShowHideModal}
            onClickUpdate={onUpdateStock}
            loading={loading?.update}
            onChangeAmount={handleChangeInputSeparator}
            onChangeUnitValue={handleChangeInputUnitValueSeparator}
            displayAmount={displayAmount}
            displayUnitValue={displayUnitValue}
          />
        </SidebarDetails>

        <SidebarDetails
          open={showModal?.bulkQrCode}
          title="Print QR Bulk"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => onShowHideModal('bulkQrCode', false)}
        >
          <BulkIDStockModal
            isOpen={showModal?.bulkQrCode}
            onClose={() => onShowHideModal('bulkQrCode', false)}
            selectedStocks={modalInventoryList}
            initialSelectedIds={selectedInventoryList.map(s => s.id)}
            totalItems={modalInventoryTotalItems}
            onLoadMore={() => fetchModalInventory(modalInventoryPage + 1)}
            onSelectAll={() => fetchModalInventory(0, true)}
            isLoading={isFetchingModalInventory}
          />
        </SidebarDetails>

        {/* NEW FOR TRANFORM */}
        <SidebarDetails
          open={showModal?.transform && isTransform}
          title="Proses"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => onShowHideModal('transform', false)}
          style={{ border: 'none' }}
        >
          <TransformModal
            onUpdateStock={onUpdateStock}
            isLoading={loading?.update}
            selectedStock={selectedStock}
            notes={notes}
            setNotes={setNotes}
            transformItems={transformItems}
            setTransformItems={setTransformItems}
            itemsList={
              itemsList?.length
                ? itemsList?.map((item) => ({
                    value: item?.id,
                    label: item?.nameItem,
                    image: item?.linkFoto,
                  }))
                : []
            }
          />
        </SidebarDetails>
        {/* END NEW FOR TRANFORM */}
        <SidebarDetails
          open={showModal?.processSplit}
          title="Detail Informasi"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => {
            setSplitItems([])
            onShowHideModal('processSplit', false)
          }}
        >
          <ProcessSplitStockModal
            isOpen={showModal?.processSplit}
            selectedStock={selectedStock}
            splitItems={splitItems}
            enableSplit={enableSplit}
            addSplitItem={addSplitItem}
            onShowItem={onShowHideModal}
            onSelectItemUnit={(item, index) => onSelectItemUnit(item, index)}
            setIndexSelectedSplitStock={(index) =>
              setIndexSelectedSplitStock(index)
            }
            onChangeValue={onChangeValueStock}
            onSplitStock={onSplitStock}
            loading={loading.split}
            onLockValue={(item) => onLockValue(item)}
          />
        </SidebarDetails>

        <SidebarDetails
          open={showModal?.split}
          title="Detail Informasi"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => {
            setSplitItems([])
            onShowHideModal('split', false)
            setBulkSplitCount(1)
          }}
        >
          <SplitStockModal
            isOpen={showModal?.split}
            selectedStock={selectedStock}
            splitItems={splitItems}
            enableSplit={enableSplit}
            addSplitItem={() => {
              addSplitItem('', '', bulkSplitCount)
              setBulkSplitCount(1)
            }}
            onShowItem={onShowHideModal}
            onSelectItemUnit={(item, index) => onSelectItemUnit(item, index)}
            setIndexSelectedSplitStock={(index) =>
              setIndexSelectedSplitStock(index)
            }
            onChangeValue={onChangeValueStock}
            onSplitStock={() => {
              const totalAmount = splitItems.reduce((sum, item) => {
                const amountStr = String(item.amount || '0').replace(',', '.') // ganti koma dengan titik
                const numericValue = parseFloat(amountStr)
                return sum + (isNaN(numericValue) ? 0 : numericValue)
              }, 0)

              const originalAmount = parseFloat(
                selectedStock?.amount?.replace(',', '.') ?? 0,
              )
              if (totalAmount !== originalAmount) {
                setShowModal((prev) => ({ ...prev, confirmSplit: true }))
              } else {
                onSplitStock()
              }
            }}
            loading={loading.split}
            onLockValue={(item) => onLockValue(item)}
            bulkSplitCount={bulkSplitCount}
            setBulkSplitCount={setBulkSplitCount}
          />
        </SidebarDetails>
        <SidebarDetails
          open={showModal?.merge}
          title="Gabungkan Inventori"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => {
            setSelectedInventoryList([])
            onShowHideModal('merge', false)
          }}
        >
          <MergeStockModal
            selectedList={selectedInventoryList}
            isOpen={showModal?.merge}
            onClose={() => {
              setSelectedInventoryList([])
              onShowHideModal('merge', false)
            }}
            selectedStock={selectedStock}
            data={inventoryGabungList}
            onSelectStock={(item) => onSelectStock(item)}
            currentPage={paginationGabung?.currentPage}
            totalPage={paginationGabung?.totalPages}
            onClickPagination={(type) => onClickNextBack(type)}
            onMergeStock={onMergeStock}
            onShowHideModal={onShowHideModal}
            loading={loading.merge}
          />
        </SidebarDetails>
        <SidebarDetails
          isBack
          handleBack={() => {
            handleResetDataStock()
            onShowHideModal('merge', true)
            onShowHideModal('addStock', false)
          }}
          open={showModal?.addStock}
          title="Gabungkan Menjadi"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => {
            setSelectedInventoryList([])
            onShowHideModal('addStock', false)
          }}
        >
          <AddStockSidebar
            onClose={() => {
              handleResetDataStock()
              setSelectedInventoryList([])
              onShowHideModal('addStock', false)
            }}
            selectedStock={selectedStock}
            data={inventoryList}
            onShowItem={onShowHideModal}
            currentPage={currentPage}
            totalPage={totalPages}
            onClickPagination={(type) => onClickNextBack(type)}
            onMergeStock={onMergeStock}
            onShowHideModal={onShowHideModal}
            loading={loading.addStock}
            dataStock={dataStock}
            onChangeDataStock={onChangeDataStock}
          />
        </SidebarDetails>
        <MergeInventoryModal
          isOpen={showModal?.mergeInventory}
          selectedInventoryList={
            showModal?.mergeInventory ? selectedInventoryList : []
          }
          onClose={() => onShowHideModal('mergeInventory', false)}
          items={itemsInventory}
          onChangeDataStock={onChangeDataStock}
          onSelectItem={(item) => onSelectItem(item)}
          dataStock={dataStock}
          onChangeAmount={handleChangeInputSeparator}
          onSelectItemUnit={(item) => onSelectItemUnit(item)}
          onMergeStock={onMergeStock}
          loading={loading?.merge}
          selectedUnit={selectedUnit}
          displayAmount={displayAmount}
          setDisplayAmount={setDisplayAmount}
        />
        <ItemModal
          isOpen={showModal?.item}
          itemsList={itemsInventory}
          onClose={() => onShowHideModal('item', false)}
          onSelectItem={(item) => onSelectItem(item)}
          loading={loading?.getItems}
        />
        <ItemUnitModal
          isOpen={showModal?.itemUnit}
          onClose={() => onShowHideModal('itemUnit', false)}
          onSelectItemUnit={(item) => onSelectItemUnit(item)}
        />
        <ConfirmRemoveInventory
          isOpen={showModal?.confirmRemove}
          onClose={() => {
            onShowHideModal('confirmRemove', false)
            // setSelectedDataRemove({})
          }}
          onSelectItemUnit={(item) => onSelectItemUnit(item)}
          handleRemoveStock={(data) => handleRemoveStock(data)}
          disabled={loading?.removeStock}
          selectedDataRemove={selectedDataRemove}
          onChangeAmount={handleChangeInputSeparator}
          displayAmount={displayAmount}
        />
        {/* <ConfirmRemoveModal
          isOpen={showModal?.confirmRemove}
          onClose={() => onShowHideModal('confirmRemove', false)}
          onSelectItemUnit={(item) => onSelectItemUnit(item)}
          onRemoveStock={() => onRemoveStock(selectedStock?.id)}
          disabled={loading?.removeStock}
        /> */}
        <ConfirmRemoveMultipleModal
          selectedInventoryList={selectedInventoryList}
          isOpen={showModal?.confirmRemoveMultiple}
          onClose={() => onShowHideModal('confirmRemoveMultiple', false)}
          onSelectItemUnit={(item) => onSelectItemUnit(item)}
          onRemoveStock={(data) => onRemoveStock(data)}
          disabled={loading?.removeStock}
          data={selectedInventoryList}
          onRemoveGroup={(data) => onRemoveGroup(data)}
        />
        <SidebarDetails
          open={showModal?.detail}
          title="Detail Informasi"
          size="lg"
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={() => onShowHideModal('detail', false)}
        >
          <DetailModal
            onClose={() => onShowHideModal('detail', false)}
            selectedStock={selectedStock}
            onClickMenu={() => onShowHideModal('menuOption', true)}
            status={profile?.status}
            onSetGroup={() => {
              setSelectedFolder({})
              setIdsGroup(defaultWarehouse?.id ? [defaultWarehouse] : [])
              onShowHideModal('addItemToGroup', true)
              fetchGroupInventory(
                0,
                9999,
                '',
                selectedSortGroup?.type || 'updatedAt',
                selectedSortGroup?.mode,
                '',
                selectedStock?.groupId,
                'folder',
              )
            }}
            onMoveOutGroup={() => {
              onShowHideModal('removeItemPacking', true)
            }}
            onMovePack={() => {
              handleOpenMoveInventoryModal([selectedStock])
            }}
          />
        </SidebarDetails>
        <AssignLotIDModal
          isOpen={showModal?.assignLotID}
          onCloseModal={() => onShowHideModal('assignLotID', false)}
          groupId={parentGroupId || selectedPacking?.id}
          setIsFetch={() => setIsFetch(parentGroupId ? 'inventory' : 'all')}
          isDetail={isDetail}
          selectedInventoryList={selectedInventoryList}
          onClearSelected={() => {
            setSelectedInventoryList([])
            setSelectedDataRemove([])
          }}
        />
      </>
    )
  }
}
